// Shared helpers extracted in #4657
import { AppState } from './helpers/app-state.js';
import {
	is1251,
	is3MG,
	isACC,
	isACR,
	isAES,
	isAND,
	isARC,
	isASP,
	isASPT,
	isAV,
	isBB,
	isBW,
	isBOH,
	isCER,
	isEDM,
	isETN,
	isFF,
	isFAV,
	isGDC,
	isGG,
	isGPG,
	isH5H,
	isHTC,
	isIQ3,
	isJMH,
	isJMS,
	isLT,
	isLLProducts,
	isMAR,
	isMAZ,
	isMH,
	isNMS,
	isNTH,
	isONW,
	isORR,
	isPC,
	isPHJ,
	isPSS,
	isRAD,
	isROK,
	isSEQ,
	isSTK,
	isTBC,
	isTCA,
	isTSG,
	isUA,
	isUSV,
	isVMS,
	isVERM,
	isAlera,
	isFish,
	isSheetz,
	isStaging,
	isUllico,
	isVestria,
	roomsVueRewriteEnabled,
} from './helpers/client-flags.js';
import {
	urlBase,
	postURL,
	addminURL,
	shareholderURL,
	clientURL,
	cloudinaryURL,
	urlTransactions,
	authUploadUrl,
	authLinkUrl,
	roomsURL,
	albumsAPI,
	calendarAPI,
	customCapTableColumnsAPI,
	capTableSummaryCardsAPI,
	getCalendarAPI,
	lambdaStatusUrl,
	lambdaStatusDataUrl,
	getEncDataAPI,
	putEncDataAPI,
	getQBIntegrationStatusAPI,
	qbInitCredsAPI,
	qbTriggerDataSyncAPI,
	dwollaTokenAPI,
	getVaultKeyAPI,
	putVaultDataAPI,
	getVaultDataAPI,
	searchWorkflowsAPI,
	adminActivityFeedUrl,
} from './helpers/api-urls.js';
import {
	csp,
	usd,
	usp,
	m0,
	m2,
	m3,
	m4,
	m5,
	m6,
	m8,
	axconf,
	dateFormats,
	imgTypes,
	xlsTypes,
	docTypes,
	mixTypes,
	nthColor,
	stdColor,
} from './helpers/number-formats.js';
import { sortByDate, dateTimeUTC, timeStampUTC, normalizeDateString } from './helpers/date-utils.js';
import {
	getCertNumber,
	capitalize,
	singular,
	formatPhone,
	formatSSN,
	formatEIN,
	maskTaxIdLast4,
	stripSubAddress,
	itsTempAddress,
	cleanStampedName,
	sanitizeHeaderFilename,
	formatImg,
	formatPreview,
	uuidv4,
	getCAGR,
	sortByFFM,
	evaluateAsFloat,
	getAllUrlParams,
	splitAddressFields,
	cleanCSV,
	secureFormData,
	numToWords,
	decimalToWords,
	stringifyNumber,
	arr,
	num,
	str,
	isEmpty,
	take,
	drop,
	reverse,
	comp,
	not,
	chunk,
	getInitials as getInitialsPure,
} from './helpers/string-utils.js';

// Compression lib for handling large session storage. Maybe this should be moved somewhere else?
let LZString = (function () {
	let r = String.fromCharCode,
		o = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=',
		n = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+-$',
		e = {};
	function t(r, o) {
		if (!e[r]) {
			e[r] = {};
			for (let n = 0; n < r.length; n++) e[r][r.charAt(n)] = n;
		}
		return e[r][o];
	}
	const i = {
		compressToBase64: function (r) {
			if (null == r) return '';
			let n = i._compress(r, 6, function (r) {
				return o.charAt(r);
			});
			switch (n.length % 4) {
				default:
				case 0:
					return n;
				case 1:
					return n + '===';
				case 2:
					return n + '==';
				case 3:
					return n + '=';
			}
		},
		decompressFromBase64: function (r) {
			return null == r
				? ''
				: '' == r
					? null
					: i._decompress(r.length, 32, function (n) {
							return t(o, r.charAt(n));
						});
		},
		compressToUTF16: function (o) {
			return null == o
				? ''
				: i._compress(o, 15, function (o) {
						return r(o + 32);
					}) + ' ';
		},
		decompressFromUTF16: function (r) {
			return null == r
				? ''
				: '' == r
					? null
					: i._decompress(r.length, 16384, function (o) {
							return r.charCodeAt(o) - 32;
						});
		},
		compressToUint8Array: function (r) {
			const o = i.compress(r),
				n = new Uint8Array(2 * o.length),
				t = o.length;
			for (let e = 0; e < t; e++) {
				let s = o.charCodeAt(e);
				((n[2 * e] = s >>> 8), (n[2 * e + 1] = s % 256));
			}
			return n;
		},
		decompressFromUint8Array: function (o) {
			if (null == o) return i.decompress(o);
			const n = new Array(o.length / 2),
				t = n.length;
			for (let e = 0; e < t; e++) n[e] = 256 * o[2 * e] + o[2 * e + 1];
			let s = [];
			return (
				n.forEach(function (o) {
					s.push(r(o));
				}),
				i.decompress(s.join(''))
			);
		},
		compressToEncodedURIComponent: function (r) {
			return null == r
				? ''
				: i._compress(r, 6, function (r) {
						return n.charAt(r);
					});
		},
		decompressFromEncodedURIComponent: function (r) {
			return null == r
				? ''
				: '' == r
					? null
					: ((r = r.replace(/ /g, '+')),
						i._decompress(r.length, 32, function (o) {
							return t(n, r.charAt(o));
						}));
		},
		compress: function (o) {
			return i._compress(o, 16, function (o) {
				return r(o);
			});
		},
		_compress: function (r, o, n) {
			if (null == r) return '';
			let e,
				t,
				i,
				s = {},
				u = {},
				a = '',
				p = '',
				c = '',
				l = 2,
				f = 3,
				h = 2,
				d = [],
				m = 0,
				v = 0;
			for (i = 0; i < r.length; i += 1)
				if (
					((a = r.charAt(i)),
					Object.prototype.hasOwnProperty.call(s, a) || ((s[a] = f++), (u[a] = !0)),
					(p = c + a),
					Object.prototype.hasOwnProperty.call(s, p))
				)
					c = p;
				else {
					if (Object.prototype.hasOwnProperty.call(u, c)) {
						if (c.charCodeAt(0) < 256) {
							for (e = 0; e < h; e++) ((m <<= 1), v == o - 1 ? ((v = 0), d.push(n(m)), (m = 0)) : v++);
							for (t = c.charCodeAt(0), e = 0; e < 8; e++)
								((m = (m << 1) | (1 & t)), v == o - 1 ? ((v = 0), d.push(n(m)), (m = 0)) : v++, (t >>= 1));
						} else {
							for (t = 1, e = 0; e < h; e++) ((m = (m << 1) | t), v == o - 1 ? ((v = 0), d.push(n(m)), (m = 0)) : v++, (t = 0));
							for (t = c.charCodeAt(0), e = 0; e < 16; e++)
								((m = (m << 1) | (1 & t)), v == o - 1 ? ((v = 0), d.push(n(m)), (m = 0)) : v++, (t >>= 1));
						}
						(0 == --l && ((l = Math.pow(2, h)), h++), delete u[c]);
					} else for (t = s[c], e = 0; e < h; e++) ((m = (m << 1) | (1 & t)), v == o - 1 ? ((v = 0), d.push(n(m)), (m = 0)) : v++, (t >>= 1));
					(0 == --l && ((l = Math.pow(2, h)), h++), (s[p] = f++), (c = String(a)));
				}
			if ('' !== c) {
				if (Object.prototype.hasOwnProperty.call(u, c)) {
					if (c.charCodeAt(0) < 256) {
						for (e = 0; e < h; e++) ((m <<= 1), v == o - 1 ? ((v = 0), d.push(n(m)), (m = 0)) : v++);
						for (t = c.charCodeAt(0), e = 0; e < 8; e++) ((m = (m << 1) | (1 & t)), v == o - 1 ? ((v = 0), d.push(n(m)), (m = 0)) : v++, (t >>= 1));
					} else {
						for (t = 1, e = 0; e < h; e++) ((m = (m << 1) | t), v == o - 1 ? ((v = 0), d.push(n(m)), (m = 0)) : v++, (t = 0));
						for (t = c.charCodeAt(0), e = 0; e < 16; e++)
							((m = (m << 1) | (1 & t)), v == o - 1 ? ((v = 0), d.push(n(m)), (m = 0)) : v++, (t >>= 1));
					}
					(0 == --l && ((l = Math.pow(2, h)), h++), delete u[c]);
				} else for (t = s[c], e = 0; e < h; e++) ((m = (m << 1) | (1 & t)), v == o - 1 ? ((v = 0), d.push(n(m)), (m = 0)) : v++, (t >>= 1));
				0 == --l && ((l = Math.pow(2, h)), h++);
			}
			for (t = 2, e = 0; e < h; e++) ((m = (m << 1) | (1 & t)), v == o - 1 ? ((v = 0), d.push(n(m)), (m = 0)) : v++, (t >>= 1));
			for (;;) {
				if (((m <<= 1), v == o - 1)) {
					d.push(n(m));
					break;
				}
				v++;
			}
			return d.join('');
		},
		decompress: function (r) {
			return null == r
				? ''
				: '' == r
					? null
					: i._decompress(r.length, 32768, function (o) {
							return r.charCodeAt(o);
						});
		},
		_decompress: function (o, n, e) {
			let t,
				i,
				s,
				u,
				a,
				p,
				c,
				l = [],
				f = 4,
				h = 4,
				d = 3,
				m = '',
				v = [],
				g = { val: e(0), position: n, index: 1 };
			for (t = 0; t < 3; t += 1) l[t] = t;
			for (s = 0, a = Math.pow(2, 2), p = 1; p != a; )
				((u = g.val & g.position),
					(g.position >>= 1),
					0 == g.position && ((g.position = n), (g.val = e(g.index++))),
					(s |= (u > 0 ? 1 : 0) * p),
					(p <<= 1));
			switch (s) {
				case 0:
					for (s = 0, a = Math.pow(2, 8), p = 1; p != a; )
						((u = g.val & g.position),
							(g.position >>= 1),
							0 == g.position && ((g.position = n), (g.val = e(g.index++))),
							(s |= (u > 0 ? 1 : 0) * p),
							(p <<= 1));
					c = r(s);
					break;
				case 1:
					for (s = 0, a = Math.pow(2, 16), p = 1; p != a; )
						((u = g.val & g.position),
							(g.position >>= 1),
							0 == g.position && ((g.position = n), (g.val = e(g.index++))),
							(s |= (u > 0 ? 1 : 0) * p),
							(p <<= 1));
					c = r(s);
					break;
				case 2:
					return '';
			}
			for (l[3] = c, i = c, v.push(c); ; ) {
				if (g.index > o) return '';
				for (s = 0, a = Math.pow(2, d), p = 1; p != a; )
					((u = g.val & g.position),
						(g.position >>= 1),
						0 == g.position && ((g.position = n), (g.val = e(g.index++))),
						(s |= (u > 0 ? 1 : 0) * p),
						(p <<= 1));
				switch ((c = s)) {
					case 0:
						for (s = 0, a = Math.pow(2, 8), p = 1; p != a; )
							((u = g.val & g.position),
								(g.position >>= 1),
								0 == g.position && ((g.position = n), (g.val = e(g.index++))),
								(s |= (u > 0 ? 1 : 0) * p),
								(p <<= 1));
						((l[h++] = r(s)), (c = h - 1), f--);
						break;
					case 1:
						for (s = 0, a = Math.pow(2, 16), p = 1; p != a; )
							((u = g.val & g.position),
								(g.position >>= 1),
								0 == g.position && ((g.position = n), (g.val = e(g.index++))),
								(s |= (u > 0 ? 1 : 0) * p),
								(p <<= 1));
						((l[h++] = r(s)), (c = h - 1), f--);
						break;
					case 2:
						return v.join('');
				}
				if ((0 == f && ((f = Math.pow(2, d)), d++), l[c])) m = l[c];
				else {
					if (c !== h) return null;
					m = i + i.charAt(0);
				}
				(v.push(m), (l[h++] = i + m.charAt(0)), (i = m), 0 == --f && ((f = Math.pow(2, d)), d++));
			}
		},
	};
	return i;
})();
window.LZString = LZString;

// Mutable state is now managed by AppState (see helpers/app-state.js).
// The bidirectional window.* bridge keeps page scripts working.

let narrow = screen.width < 600;
AppState.narrow = narrow;
let hn = window.location.hostname;
AppState.hn = hn;
let pn = window.location.pathname;
AppState.pn = pn;

const env = getEnv();
const client = getClient();
const authedUser = getCookie('nth.userid');
const getAuthedUser = () => getCookie('nth.userid');
const nthAdmin = authedUser.endsWith('@nthround.com');

// Bridge immutable identifiers via AppState (syncs to window.* automatically)
AppState.env = env;
AppState.client = client;
AppState.authedUser = authedUser;
window.getAuthedUser = getAuthedUser;
AppState.nthAdmin = nthAdmin;

// Bridge client flags to window.* for page scripts
window.is1251 = is1251;
window.is3MG = is3MG;
window.isACC = isACC;
window.isACR = isACR;
window.isAES = isAES;
window.isAND = isAND;
window.isARC = isARC;
window.isASP = isASP;
window.isASPT = isASPT;
window.isAV = isAV;
window.isBB = isBB;
window.isBW = isBW;
window.isBOH = isBOH;
window.isCER = isCER;
window.isEDM = isEDM;
window.isETN = isETN;
window.isFF = isFF;
window.isFAV = isFAV;
window.isGDC = isGDC;
window.isGG = isGG;
window.isGPG = isGPG;
window.isH5H = isH5H;
window.isHTC = isHTC;
window.isIQ3 = isIQ3;
window.isJMH = isJMH;
window.isJMS = isJMS;
window.isLT = isLT;
window.isLLProducts = isLLProducts;
window.isMAR = isMAR;
window.isMAZ = isMAZ;
window.isMH = isMH;
window.isNMS = isNMS;
window.isNTH = isNTH;
window.isONW = isONW;
window.isORR = isORR;
window.isPC = isPC;
window.isPHJ = isPHJ;
window.isPSS = isPSS;
window.isRAD = isRAD;
window.isROK = isROK;
window.isSEQ = isSEQ;
window.isSTK = isSTK;
window.isTBC = isTBC;
window.isTCA = isTCA;
window.isTSG = isTSG;
window.isUA = isUA;
window.isUSV = isUSV;
window.isVMS = isVMS;
window.isVERM = isVERM;
window.isAlera = isAlera;
window.isFish = isFish;
window.isSheetz = isSheetz;
window.isStaging = isStaging;
window.isUllico = isUllico;
window.isVestria = isVestria;
window.roomsVueRewriteEnabled = roomsVueRewriteEnabled;

// Feature constants are now initialized by AppState with their defaults.

// Feature flags are now managed by AppState (see helpers/app-state.js).
// Set PUBLISH_INV_AGMT which depends on client flags.
AppState.PUBLISH_INV_AGMT = isStaging || isONW || isPHJ || isFF || isHTC;

// Bridge formatters and colors to window.* for page scripts
window.csp = csp;
window.usd = usd;
window.usp = usp;
window.m0 = m0;
window.m2 = m2;
window.m3 = m3;
window.m4 = m4;
window.m5 = m5;
window.m6 = m6;
window.m8 = m8;
window.axconf = axconf;
window.dateFormats = dateFormats;
window.imgTypes = imgTypes;
window.xlsTypes = xlsTypes;
window.docTypes = docTypes;
window.mixTypes = mixTypes;
window.nthColor = nthColor;
window.stdColor = stdColor;

// Bridge API URLs to window.* for page scripts
window.urlBase = urlBase;
window.postURL = postURL;
window.addminURL = addminURL;
window.shareholderURL = shareholderURL;
window.clientURL = clientURL;
window.cloudinaryURL = cloudinaryURL;
window.urlTransactions = urlTransactions;
window.authUploadUrl = authUploadUrl;
window.authLinkUrl = authLinkUrl;
window.roomsURL = roomsURL;
window.albumsAPI = albumsAPI;
window.calendarAPI = calendarAPI;
window.customCapTableColumnsAPI = customCapTableColumnsAPI;
window.capTableSummaryCardsAPI = capTableSummaryCardsAPI;
window.getCalendarAPI = getCalendarAPI;
window.lambdaStatusUrl = lambdaStatusUrl;
window.lambdaStatusDataUrl = lambdaStatusDataUrl;
window.getEncDataAPI = getEncDataAPI;
window.putEncDataAPI = putEncDataAPI;
window.getQBIntegrationStatusAPI = getQBIntegrationStatusAPI;
window.qbInitCredsAPI = qbInitCredsAPI;
window.qbTriggerDataSyncAPI = qbTriggerDataSyncAPI;
window.dwollaTokenAPI = dwollaTokenAPI;
window.getVaultKeyAPI = getVaultKeyAPI;
window.putVaultDataAPI = putVaultDataAPI;
window.getVaultDataAPI = getVaultDataAPI;
window.searchWorkflowsAPI = searchWorkflowsAPI;
window.adminActivityFeedUrl = adminActivityFeedUrl;

const loader = `<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="24px" height="30px" viewBox="0 0 24 30" style="enable-background:new 0 0 50 50;" xml:space="preserve">
	<rect x="0" y="13" width="4" height="5" fill="#333"><animate attributeName="height" attributeType="XML"	values="5;21;5" begin="0s" dur="0.6s" repeatCount="indefinite" /><animate attributeName="y" attributeType="XML" values="13; 5; 13" begin="0s" dur="0.6s" repeatCount="indefinite" /></rect>
	<rect x="10" y="13" width="4" height="5" fill="#333"><animate attributeName="height" attributeType="XML" values="5;21;5" begin="0.15s" dur="0.6s" repeatCount="indefinite" /><animate attributeName="y" attributeType="XML" values="13; 5; 13" begin="0.15s" dur="0.6s" repeatCount="indefinite" /></rect>
	<rect x="20" y="13" width="4" height="5" fill="#333"><animate attributeName="height" attributeType="XML" values="5;21;5" begin="0.3s" dur="0.6s" repeatCount="indefinite" /><animate attributeName="y" attributeType="XML" values="13; 5; 13" begin="0.3s" dur="0.6s" repeatCount="indefinite" /></rect></svg>`;
window.loader = loader;

const greenCheck = `<span class="material-icons-outlined align-middle" style="color: green; font-size: 30px;" title="All okay">check</span>`;
window.greenCheck = greenCheck;
const orangeQuestion = `<span class="material-icons-outlined align-middle" style="color: orange; font-size: 30px;">question_mark</span>`;
window.orangeQuestion = orangeQuestion;
const redClear = `<span class="material-icons-outlined align-middle" style="color: red; font-size: 36px; font-weight: 900" title="Problem with this row">clear</span>`;
window.redClear = redClear;

const achTerms = `<div class="modal-content"><div class="p-1"><h3 class="text-lg center-align">ACH Authorization</h3>
	<p class="text-xs">When you use Nth Round's services for ACH credit and debit transactions, you, as the Originator, authorize Nth Round as a Third Party Sender under Nacha Operating Rules to to initiate these credit and debit entries to your bank account, referred to as <span class="bank-account"></span>. This includes handling any necessary adjustments or corrections for transactions that were wrongly credited or debited, as well as complying with legal requirements. Your permission for Nth Round to carry out these transactions remains in effect until you provide written notice to cancel it, giving them enough time to respond appropriately.</p>
	<p class="text-xs">By providing your bank account details (<span class="bank-account"></span>) during the onboarding process, you confirm that this account belongs to you and that you have the authority to authorize these credit and debit transactions.</p>
	<div class="mt-6"><img class="footer-icon left" style="margin-left: 0.2rem;" src="../../resources/assets/logo_round.svg"/><span class="text-xs left">Nth Round, Inc.</span><a id="achAgreementClose" href="#" class="modal-close link-accent text-sm mt-0 mb-6 mr-4 right">Close</a></div></div>`;
window.achTerms = achTerms;

let NthUtil = {
	http: {
		nthAxiosClient: undefined,
	},
	test: {
		// feature flags for testing features can go here
	},
	sessionStore: {
		get: (k) => {
			const decompressedValue = LZString.decompress(sessionStorage.getItem(k));
			// LZString lib will return null if the value is not compressed; so if it returns anything, that means decompression succeeded.
			if (decompressedValue != null) {
				return decompressedValue;
			}
			// Here we can assume the value in sessionStorage was _not_ compressed, so we can just return it.
			return sessionStorage.getItem(k);
		},
		set: (k, v) => {
			return sessionStorage.setItem(k, LZString.compress(v));
		},
		shouldCompressClient: (c) => {
			return [
				'www.staging',
				'asplundh',
				'aleragroup',
				'onwardgroup',
				'orrick',
				'gpgventures',
				'historicpreservation',
				'practicalvc',
				'ceritypartners',
				'barry-wehmiller',
				'jmsearch',
			].includes(c);
		},
	},
};
// Fingerprint of the cap table saved in this browser (from shareholderData with_hash/latest).
// Any write to the saved copy drops it; callers that know the hash set it again afterwards.
NthUtil.sessionStore.getCapTableHash = (c) => {
	try {
		return sessionStorage.getItem(c + '.CapTableHash') || null;
	} catch (e) {
		return null;
	}
};
NthUtil.sessionStore.setCapTableHash = (c, hash) => {
	try {
		if (hash) sessionStorage.setItem(c + '.CapTableHash', hash);
		else sessionStorage.removeItem(c + '.CapTableHash');
	} catch (e) {}
};
NthUtil.sessionStore.updateCapTable = (c, newData) => {
	NthUtil.sessionStore.setCapTableHash(c, null);
	if (!getAuthType().includes('admin') && !window.isSupv && !window.isExec) {
		window.capTableData = null;
		if (typeof CapTableCacheService !== 'undefined') CapTableCacheService.clear(c);
		return; // users never should see entire cap table
	}
	if (typeof CapTableCacheService !== 'undefined') {
		CapTableCacheService.set(c, newData, NthUtil.sessionStore.shouldCompressClient(c));
		return;
	}
	// Fallback if cache service not loaded yet
	if (NthUtil.sessionStore.shouldCompressClient(c)) {
		return NthUtil.sessionStore.set(c + '.CapTable', JSON.stringify(newData));
	}
	return sessionStorage.setItem(c + '.CapTable', JSON.stringify(newData));
};
NthUtil.sessionStore.hasCapTable = (c) => {
	if (typeof CapTableCacheService !== 'undefined' && CapTableCacheService.get(c)) return true;
	try {
		let raw = sessionStorage.getItem(c + '.CapTable');
		return raw && raw !== '';
	} catch (error) {
		return false;
	}
};
NthUtil.sessionStore.readCapTable = (c) => {
	// Try in-memory cache first (no decompression needed)
	if (typeof CapTableCacheService !== 'undefined') {
		const cached = CapTableCacheService.get(c);
		if (cached) return cached;
	}
	// Fallback: synchronous decompress (only hit on cold load before worker finishes)
	try {
		let sessionData = typeof CapTableCacheService !== 'undefined' ? CapTableCacheService.readSaved(c) : NthUtil.sessionStore.get(c + '.CapTable');
		if (sessionData && sessionData !== '') {
			let data = JSON.parse(sessionData);
			if (Array.isArray(data)) {
				// Populate cache for subsequent reads
				if (typeof CapTableCacheService !== 'undefined') {
					CapTableCacheService._cache[c] = data;
					CapTableCacheService.noteSaved(c, sessionData);
				}
				return data;
			}
			console.error(`readCapTable: Data is not an array for client ${c}`);
			return [];
		}
		console.warn(`readCapTable: No data in sessionStorage for client ${c}`);
		return [];
	} catch (error) {
		console.error(`readCapTable: JSON parse failed for client ${c}:`, error);
		return [];
	}
};

// DO NOT USE - FAILS AUTHORIZATION - NO COOKIE IN HEADER
NthUtil.http.nthAxios = () => {
	// If the client is already instantiated, just return it
	if (typeof NthUtil.http.nthAxiosClient !== 'undefined') {
		return NthUtil.http.nthAxiosClient;
	}

	const baseClient = axios.create({
		baseURL: urlBase,
	});

	// cookie is sent in the request body
	baseClient.defaults.withCredentials = false;

	baseClient.defaults.headers.post['Content-Type'] = 'application/json';
	baseClient.defaults.headers.put['Content-Type'] = 'application/json';
	baseClient.defaults.headers.patch['Content-Type'] = 'application/json';
	baseClient.interceptors.request.use((config) => {
		const commonParams = {
			client: getClient(),
			cookie: getCookie(),
			userid: getAuthedUser(),
		};

		switch (config.method) {
			case 'get':
				config.params = {
					...commonParams,
					...config.params,
				};
				break;
			case 'post':
				config.data = {
					...commonParams,
					...config.data,
				};
				break;
			case 'put':
				config.data = {
					...commonParams,
					...config.data,
				};
				break;
			case 'delete':
				config.params = {
					...commonParams,
					...config.params,
				};
				break;
			case 'patch':
				config.params = {
					...commonParams,
					...config.body,
				};
				break;
			default:
				return false;
		}
		return config;
	});
	NthUtil.http.nthAxiosClient = baseClient;
	return baseClient;
};
window.NthUtil = NthUtil;

// Presigned URL utility for content bucket files (replaces direct CloudFront URLs)
async function getContentUrl(filename) {
	const response = await axios.get('https://api.nthround.io/portal/auth/get-presigned-url', {
		params: {
			client: client,
			userid: authedUser,
			cookie: getCookie(),
			doc_name: filename,
			bucket: 'reports.nthround.io',
		},
	});
	return response.data;
}
window.getContentUrl = getContentUrl;

// Bridge shared template image helper to window, bound to this module's getContentUrl
import { rewriteTemplateImagesToPresigned as _rewriteTemplateImagesToPresigned } from './helpers/template-images.js';
window.rewriteTemplateImagesToPresigned = function (html, buildKey) {
	return _rewriteTemplateImagesToPresigned(html, buildKey, { getContentUrlFn: getContentUrl });
};

// Presigned URL utility for snapshot bucket files (d3joenepwjic7e)
async function getSnapshotUrl(s3Key) {
	const response = await axios.get('https://api.nthround.io/portal/auth/get-presigned-url', {
		params: {
			client: client,
			userid: authedUser,
			cookie: getCookie(),
			doc_name: s3Key,
			bucket: 'captables.nthround.io',
		},
	});
	return response.data;
}
window.getSnapshotUrl = getSnapshotUrl;

// Download a file via presigned URL (for <a href> replacements)
async function downloadPresigned(filename, displayName) {
	try {
		const url = await getContentUrl(filename);
		const link = document.createElement('a');
		link.href = url;
		link.download = displayName || filename;
		link.target = '_blank';
		document.body.appendChild(link);
		link.click();
		document.body.removeChild(link);
	} catch (err) {
		console.error('Failed to get presigned URL for download:', err);
	}
}
window.downloadPresigned = downloadPresigned;

AppState.blurNames = sessionStorage.getItem('blurnames');
document.addEventListener('keydown', doBlur);

function doBlur(e) {
	if (e.altKey && e.ctrlKey && nthAdmin) {
		if (!window.blurNames) {
			window.blurBlock = true;
			window.blurNames = 'WAIT';
			console.log('BLUR: altKey = ' + e.altKey + ', ctrlKey = ' + e.ctrlKey);
			const blurNamesUrl = 'https://res.cloudinary.com/nthround/raw/upload/v1649448433/Names.txt';
			fetch(blurNamesUrl)
				.then(function (response) {
					return response.text();
				})
				.then(function (text) {
					window.blurNames = text;
					sessionStorage.setItem('blurnames', window.blurNames);
					setTimeout(() => {
						window.blurBlock = false;
					}, 1000);
				})
				.catch(function (err) {
					console.warn('Something went wrong.', err);
				});
		}
	}
}

function getPayerEmail(shareClass, campaign = window.activeCampaign) {
	// Return the email from the activeCampaign's payers object
	return campaign?.payers?.[shareClass] || 'NO ACTIVE CAMPAIGN / PAYER';
}

function getEnv() {
	let after_first_dot = hn.split('.')[1];
	// console.log("env: ", hn === 'localhost' ? "staging" : after_first_dot == "nthround" ? "master" : after_first_dot);
	return hn === 'localhost' ? 'staging' : after_first_dot == 'nthround' ? 'master' : after_first_dot;
	// return  "staging"
}

function getClient() {
	document.removeEventListener('keydown', doBlur);
	let host = hn;
	if (host == 'localhost' || host == 'www.staging.nthround.io') {
		let testclient = getCookie('nth.TestClient');
		if (testclient) return testclient;
	}
	// FOR DEBUGGING
	//return "onward";
	return host === 'localhost' ? 'www.staging' : host.split('.').slice(0, -2).join('.');
}

let segmentWriteKey;
// console.log('Current user: ' + JSON.stringify(user));
// If environment is production insert production scripts
// don't track if incognito
let tokenCount = document.cookie.split(';').length;
setTimeout(() => {
	if (env == 'master' && tokenCount > 0) {
		//6) {	// <-- FAILS !!!
		let gtm = document.createElement('script');
		let dataLayer = document.createElement('script');
		if (authedUser) {
			dataLayer.innerHTML = `
				dataLayer = [{'authedUser': '${authedUser}'}];
			`;
		}
		gtm.innerHTML = `
			(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
			new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
			j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
			'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
			})(window,document,'script','dataLayer','GTM-P7X3GJN');
		`;
		document.head.appendChild(gtm);
		document.head.appendChild(dataLayer);

		let gt = document.createElement('noscript');
		gt.innerHTML = `<iframe src="https://www.googletagmanager.com/ns.html?id=GTM-P7X3GJN" height="0" width="0" style="display:none;"></iframe>`;
		if (document.body) document.body.prepend(gt);

		// Set production Segment Write Key
		segmentWriteKey = 'NBnGWqn8N69XoAndSJMXs0ylsHtDAka7';
	} else {
		// Set staging Segment Write Key
		segmentWriteKey = 'SUo2LkzxL3eDCrt0Q8RrjjkVF8h3ntIW';
	}

	// Add the base Segment tracking code and identify calls using dynamic write key variables
	window.segment = document.createElement('script');
	window.segment.innerHTML = `
	!function(){var analytics=window.analytics=window.analytics||[];if(!analytics.initialize)if(analytics.invoked)window.console&&console.error&&console.error("Segment snippet included twice.");else{analytics.invoked=!0;analytics.methods=["trackSubmit","trackClick","trackLink","trackForm","pageview","identify","reset","group","track","ready","alias","debug","page","once","off","on","addSourceMiddleware","addIntegrationMiddleware","setAnonymousId","addDestinationMiddleware"];analytics.factory=function(e){return function(){if(window.analytics.initialized)return window.analytics[e].apply(window.analytics,arguments);var i=Array.prototype.slice.call(arguments);i.unshift(e);analytics.push(i);return analytics}};for(var i=0;i<analytics.methods.length;i++){var key=analytics.methods[i];analytics[key]=analytics.factory(key)}analytics.load=function(key,i){var t=document.createElement("script");t.type="text/javascript";t.async=!0;t.src="https://cdn.segment.com/analytics.js/v1/" + key + "/analytics.min.js";var n=document.getElementsByTagName("script")[0];n.parentNode.insertBefore(t,n);analytics._loadOptions=i};analytics._writeKey="NBnGWqn8N69XoAndSJMXs0ylsHtDAka7";;analytics.SNIPPET_VERSION="4.16.1";
	analytics.load("${segmentWriteKey}");
	analytics.page()}}();`;

	document.head.appendChild(window.segment);

	// Rooms seems to refresh this page, and double-count...
	let singleShot;
	document.addEventListener(
		'StorageComplete',
		function (e) {
			// If there is an authed user, call Segment Identify
			if (authedUser && !singleShot) {
				singleShot = true;

				if (window.clientData) {
					window.analytics.group(client, {
						userId: authedUser,
						groupId: client,
						traits: {
							name: window.clientData.company_name,
							email: window.clientData.contact_email,
							plan: window.clientData.plan,
						},
					});
				}

				window.analytics.identify(authedUser, {
					name: window.userData?.user_name,
					email: authedUser,
					userType: window.authType,
				});

				// Not doing these security checks yet, or ever?
				if (false && typeof platform !== 'undefined') {
					function json(url) {
						return fetch(url).then((res) => res.json());
					}

					let apiKey = '74e90ebd472d39ba695df5026ba9a8daf9013fb0b504ec248f848527';
					json(`https://api.ipdata.co?api-key=${apiKey}`).then((data) => {
						console.log(data);
						let location = data.latitude ? Math.round(data.latitude) + '/' + Math.round(data.longitude) : '';
						let devices = window.userData.devices || {};
						let platforms = devices.platforms || [];
						let ipAddresses = devices.ipAddresses || [];
						let locations = devices.locations || [];
						if (platform.description && !platforms.includes(platform.description)) platforms.push(platform.description);
						if (data.ip && !ipAddresses.includes(data.ip)) ipAddresses.push(data.ip);
						if (location && !locations.includes(location)) locations.push(location);
						devices.platforms = platforms;
						devices.ipAddresses = ipAddresses;
						devices.locations = locations;
						axios
							.post(
								postURL,
								JSON.stringify({
									eventName: 'auth.devices_detected',
									userid: authedUser,
									client: client,
									cookie: window.cookie,
									devices: devices,
								})
							)
							.then(function (res) {
								console.log(res);
							})
							.catch(function (err) {
								console.error(err);
							});
					});
				}
			}
		},
		false
	);
}, 250); // needs at least 100 ms delay (or call-back from nav.js?)

document.addEventListener('click', function (e) {
	if (e.target.classList.contains('log-out')) {
		e.preventDefault();
		signOut('user clicked log-out');
	}
});

function signOut(reason) {
	console.log('signOut called. Reason: ' + (reason || 'unspecified'));
	if (window.analytics) {
		window.analytics.track('Signed Out', {
			userEmail: authedUser,
			workspace: client,
		});
	}
	sessionStorage.clear();
	console.log('Logging out');
	deleteCookie('nth.userid');
	deleteCookie('nth.TestUser');
	deleteCookie('nth.TestClient');
	deleteCookie('nth.AccessToken');
	deleteCookie('nth.IdToken');
	deleteCookie('nth.RefreshToken');
	console.log('Deleted auth cookies');
	console.log('Redirecting - auth signOut');
	if (client === 'clydeinc') {
		return (window.location.href =
			'https://us-east-1yvujcsliu.auth.us-east-1.amazoncognito.com/logout?client_id=4ihfpividvqpu2l0f8e21o3ols&response_type=code&logout_uri=https%3A%2F%2Fclydext.ciamlogin.com%2Fd019c0d6-33da-42d7-a4d8-1b57bd503554%2Foauth2%2Fv2.0%2Flogout%3Fclient_id%3D9f336482-ee83-4493-a2ec-292ec9ceab1b%26redirect_uri%3Dhttps%253A%252F%252Fus-east-1yvujcsliu.auth.us-east-1.amazoncognito.com%252Foauth2%252Fidpresponse%26scope%3Dopenid%2Bemail%2Bprofile%26response_type%3Dcode%26sso_reload%3Dtrue');
	} else {
		if (!pn.includes('/signin')) window.location.replace('/signin/');
	}
}

function user_identity() {
	return 'AQICAHjyZmzK8d2PGyyv1Zve93nUW1AyRl9VZtdIMbp8zlT_-QGnQdYgENkr6V4fza1-PATGAAAAdDByBgkqhkiG9w0BBwagZTBjAgEAMF4GCSqGSIb3DQEHATAeBglghkgBZQMEAS4wEQQMQsHP70cLHkSmqNv5AgEQgDG_RwGWCB29fzvV3uy2rrC5oSOia2ccSiWsnmZFiCkBkIC7TnmbqCEHd6YQEF8gv1GO';
}

function getAuthType() {
	//if (authType || allowedPaths.includes(pn.replace(/\//g, ''))) return authType;
	if (window.authType) return window.authType;
	window.authType = 'user';
	console.log('EARLY getAuthType');
	console.trace();
	return window.authType;
}

function checkAdmin() {
	if (getAuthType().includes('admin')) {
		return true;
	} else {
		console.log('Redirected to user environment.');
		console.log('Redirecting - checkAdmin');
		window.location.replace('/');
		return false;
	}
}

function removeNthAdmins(array) {
	let filtered = array;
	if (!isNTH && !client.startsWith('onward') && !isStaging && client !== 'merioncapital') {
		// Defensive check: filter out null/undefined entries and those without userid before checking domain
		filtered = array.filter((shareholder) => shareholder?.userid && !shareholder.userid.toLowerCase().includes('nthround.com'));
		// if (isFF && authedUser.endsWith("@nthround.com")) filtered = array;
		// console.log(filtered);
	}
	return filtered;
}

function hideLoading(hideAuth = false) {
	let authed = document.getElementById('authed');
	if (authed && !hideAuth) authed.classList.remove('hidden');
	let loading = document.getElementById('loading');
	if (loading) {
		loading.classList.remove('loading');
		loading.classList.add('hidden');
		loading.style.minHeight = '';
		loading.innerHTML = '';
	}
	if (typeof M !== 'undefined' && M != null) {
		if (pn == '/investor-agreement' || pn == '/investor-agreement/' || pn == '/') {
		} else if (pn == '/proxy-voting' || pn == '/proxy-voting/') {
			//proxy
		} else if (pn == '/data-room' || pn == '/data-room/') {
			//proxy
		} else {
			let elems = document.querySelectorAll('.tabs');
			elems.forEach((elem) => M.Tabs.init(elem));
		}
	}
}

// Holder lists wait 500 ms to tell a click (Edit) from a double-click (preview); show the click registered
function holderClickFeedback(el) {
	document.body.style.cursor = 'progress';
	const row = el?.closest?.('tr') || el;
	if (row?.style) row.style.opacity = '0.5';
}

function showLoading() {
	let authed = document.getElementById('authed');
	if (authed) authed.classList.add('hidden');
	let loading = document.getElementById('loading');
	if (loading) {
		loading.style.minHeight = '85vh';
		loading.classList.remove('hidden');
		loading.innerHTML = `<div class="loader loader--style6 width-full m-auto center-align" title="5">${loader}</div>`;
		// One-shot note carried over from the previous page (e.g. "Opening the preview…")
		const note = sessionStorage.getItem('loadingNote');
		if (note) {
			sessionStorage.removeItem('loadingNote');
			const p = document.createElement('p');
			p.id = 'loadingStatus';
			p.className = 'center-align text-secondary mt-4';
			p.textContent = note;
			loading.firstElementChild.appendChild(p);
		}
	}
}

function showToast(id, msg, duration) {
	let message = msg || 'Data saved successfully!';
	let classes = 'teal lighten-2 text-sm';
	let isError = id == 'error-toast';
	if (isError) classes = 'red darken-4 text-sm';
	if (id == 'warning-toast') classes = 'blue-grey lighten-2 text-sm';

	// Error toasts default to an effectively-persistent duration (not literal
	// Infinity -- setTimeout coerces that to 0, i.e. instant) plus a close
	// button, so they don't vanish before they can be read. Explicit durations
	// still override this.
	if (duration === undefined) duration = isError ? 2147483647 : 5000;
	const html = isError
		? `<span>${message}</span><button type="button" class="btn-flat toast-action white-text" style="margin-left:auto;padding:0 8px;" onclick="this.closest('.toast')?.remove()">&times;</button>`
		: message;

	M.toast({ html, classes, displayLength: duration });
}

function firstName(userData, isHistoric) {
	if (!userData) {
		return '';
	}

	if (userData.clients?.[client]?.override_friendly_name) return userData.clients[client].override_friendly_name.replace(/_/g, ' ');
	return userData.friendly_name ? userData.friendly_name.replace(/_/g, ' ') : userData.user_name?.split(' ')[0].replace(/_/g, ' ').replace(/,$/, '') || '';
}

function nameWithOverride(thisUserid, inputCapTable) {
	let localCapTable = inputCapTable !== undefined ? inputCapTable : window.capTableData;
	let overrideName;

	if (thisUserid == client) return window.clientData?.company_name;
	if (thisUserid == 'asplundhtest') return window.clientData?.company_name;
	if (thisUserid?.startsWith('temp_asplundhtreasury')) return thisUserid;
	if (!thisUserid || thisUserid.toLowerCase() == 'issuer') return 'Issuer';

	if (thisUserid == window.userData?.userid) {
		overrideName = window.userData.clients?.[client]?.override_name;
		return overrideName ? overrideName : window.userData.user_name;
	}

	if (localCapTable?.length) {
		const thisUser = localCapTable.find((x) => x.userid == thisUserid);
		if (thisUser) {
			overrideName = thisUser?.clients?.[client]?.override_name;
			return overrideName ? overrideName : thisUser?.user_name;
		}
	}

	// Strong fallback on Edit User page or similar admin flows
	if (window.shareholderData?.userid == thisUserid) {
		overrideName = window.shareholderData?.clients?.[client]?.override_name;
		return overrideName ? overrideName : window.shareholderData?.user_name || thisUserid;
	}

	// One more try: pull fresh from session storage in case global cap table is stale
	const freshCapTable = NthUtil.sessionStore.readCapTable(client);
	if (freshCapTable?.length) {
		const thisUser = freshCapTable.find((x) => x.userid == thisUserid);
		if (thisUser) {
			overrideName = thisUser?.clients?.[client]?.override_name;
			return overrideName ? overrideName : thisUser?.user_name;
		}
	}

	if (nthAdmin) {
		console.log('Missing from cap table: ' + thisUserid);
		showToast('warning-toast', 'Missing from cap table: ' + thisUserid, 10000);
	}

	return thisUserid || '';
}

function ensureUserClientData(clientName) {
	// Initialize user data structure with defaults to prevent crashes
	if (!window.userData) window.userData = {};
	if (!window.userData.clients) window.userData.clients = {};
	if (!window.userData.clients[clientName]) {
		window.userData.clients[clientName] = {
			shares: {},
			documents: [],
			tags: [],
			conversations: [],
			alias: [],
			investor: {},
		};
	}

	// Update sessionStorage with initialized data
	sessionStorage.setItem('user.Data', JSON.stringify(window.userData));

	return window.userData.clients[clientName];
}

function friendlyNameWithOverride(thisUserid) {
	let overrideFriendlyName;
	if (thisUserid == window.userData.userid) {
		overrideFriendlyName = window.userData.clients[client].override_friendly_name;
		return overrideFriendlyName ? overrideFriendlyName : window.userData.friendly_name;
	}
	if (window.capTableData) {
		const thisUser = window.capTableData.find((x) => x.userid == thisUserid);
		if (thisUser) {
			overrideFriendlyName = thisUser?.clients[client].override_friendly_name;
			return overrideFriendlyName ? overrideFriendlyName : thisUser?.friendly_name || '';
		} else if (window.shareholderData) return window.shareholderData.friendly_name || '';
	}
	return 'UNKNOWN';
}

function getInitials(fullName) {
	return getInitialsPure(fullName, window.clientData?.initials_overrides);
}

function customFormat(stringValue) {
	if ((isAlera || isBW) && !Number.isInteger(Number(stringValue))) return m4;
	else if (isTBC) return m6;
	else return {};
}

function roundToFour(number) {
	// console.log("number = " + number);
	if (!number) return 0;
	let factor = isTBC ? 1000000 : 10000;
	if (isNaN(number)) return Math.round(Number(number.replace(/[^.\d]/g, '')) * factor) / factor;
	else return Math.round(number * factor) / factor;
}

function initializeTags(initialTags, editPage, elem, calendarEventTags = null) {
	let chipsInst;
	let tagsInputElem;
	let tagOptions = {};
	const orderedOptions = {};
	if (initialTags.length == 1 && !initialTags[0].tag) initialTags[0].tag = 'ALL';

	if (!calendarEventTags) {
		// Defensive check to prevent TypeError when clientData.equity is undefined/null
		if (window.clientData && window.clientData.equity) {
			Object.keys(window.clientData.equity)
				.sort()
				.forEach(function (t) {
					tagOptions[t] = null;
				});
		}

		// Class Tags and User Tags are both valid here by design (#3965/#4741). Legacy tag
		// scraping from company_updates/financial_statements was removed (#5958) -- unbounded
		// and never pruned; clientData.tags is the real source of truth.
		if (window.clientData && Array.isArray(window.clientData.tags)) {
			window.clientData.tags.forEach(function (t, i) {
				if (t && typeof t === 'object' && t.name) {
					tagOptions[t.name] = null;
				} else if (typeof t === 'string') {
					// Fallback for legacy/simple string tags
					tagOptions[t] = null;
				}
			});
		}

		Object.keys(tagOptions).forEach(function (key) {
			if (editPage || window.isCont) orderedOptions[key] = tagOptions[key];
		});
	} else {
		calendarEventTags.sort().forEach(function (t) {
			tagOptions[t] = null;
		});
		Object.keys(tagOptions).forEach(function (key) {
			if (window.userData.clients && window.userData.clients[client]) {
				let keyTags = window.userData.clients[client].tags[key];
				if (editPage || keyTags) orderedOptions[key] = tagOptions[key];
			}
		});
	}
	if (document.getElementById('addTag') == null) {
		let chipOptions = {
			data: initialTags,
			autocompleteOptions: {
				data: orderedOptions,
				// limit: 8,
				minLength: 0,
			},
			placeholder: 'Enter a tag',
			onChipAdd: checkChipInput,
			onChipDelete: checkChipInput,
		};
		let elems = document.querySelectorAll(elem);
		let chipInstance = M.Chips.init(elems, chipOptions);

		function checkChipInput(e) {
			let chipsData = M.Chips.getInstance(document.getElementById('tagChips')).chipsData;
			if (chipsData.length > 1) {
				chipsData = chipsData.filter(function (el) {
					return el.tag != 'ALL';
				});
			} else if (chipsData.length == 0) {
				chipsData = [{ tag: 'ALL' }]; //defaultTag;
			}
			if (calendarEventTags) {
				initializeTags(chipsData, editPage, elem, calendarEventTags);
			} else {
				initializeTags(chipsData, editPage, elem);
			}
		}

		chipsInst = M.Chips.getInstance(document.getElementById('tagChips'));
	}
}

async function geocodeAddress({ address = '', name = '', sanitize = null }) {
	// Centralized, self-contained geocode helper (axios + optional DOMPurify supported)
	// Usage examples:
	//   const out = await geocodeAddress({ address: "12 Main St, Boston MA" });
	//   const out = await geocodeAddress({ name: "Jane Doe", address: "12 Main St, Boston MA", sanitize: DOMPurify?.sanitize });
	//   if (out.ok) console.log(out.resultAddress);
	// Returns:
	//   {
	//     ok: boolean,
	//     formatted: string,
	//     street1, city, state, zip,
	//     resultAddress: "street, city, ST  ZIP",
	//     hasUnknown: boolean,
	//     raw: <google result or null>
	//   }

	try {
		const s = (v) => (sanitize ? sanitize(v) : v);

		const normalize = (str) => (str || '').toString().replace(/#/g, '').trim().replace(/\s+/g, '+');

		const buildUrl = () => {
			const apiUrl = 'https://maps.googleapis.com/maps/api/geocode/json?address=';
			const apiKey = 'AIzaSyDIEuCr5-yEQ3NbvymZDdI8yHBL2iECBEk';
			const query = [name, address].filter(Boolean).join(',');
			return apiUrl + normalize(query) + '&key=' + apiKey;
		};

		const pick = (components, type, which = 'long_name') => components?.find((c) => c.types?.[0] === type)?.[which] || '';

		const url = buildUrl();
		const res = await axios.get(url, { withCredentials: false });
		const raw = res?.data?.results?.[0] || null;
		const components = raw?.address_components || null;
		if (!components) {
			return { ok: false, formatted: '', street1: '', city: '', state: '', zip: '', resultAddress: '', hasUnknown: true, raw: null };
		}

		const formatted = raw?.formatted_address || '';
		const streetNumber = pick(components, 'street_number') || 'unknown';
		const route = pick(components, 'route') || 'unknown';
		const subpremise = pick(components, 'subpremise');

		let street1 = `${streetNumber} ${route}`;
		if (subpremise) street1 += `, ${subpremise}`;

		const city =
			pick(components, 'locality') ||
			pick(components, 'political') ||
			pick(components, 'neighborhood') ||
			pick(components, 'administrative_area_level_3') ||
			pick(components, 'postal_town') ||
			'unknown';

		const state = pick(components, 'administrative_area_level_1', 'short_name') || 'unknown';
		const zip = pick(components, 'postal_code') || 'unknown';

		street1 = s(street1);
		const outCity = s(city);
		const outState = s(state);
		const outZip = s(zip);
		const resultAddress = s(`${street1}, ${outCity}, ${outState}  ${outZip}`.replace(/, ,/g, ','));
		const hasUnknown = resultAddress.toLowerCase().includes('unknown');

		return {
			ok: true,
			formatted,
			street1,
			city: outCity,
			state: outState,
			zip: outZip,
			resultAddress,
			hasUnknown,
			raw,
		};
	} catch (err) {
		console.error(err);
		return { ok: false, formatted: '', street1: '', city: '', state: '', zip: '', resultAddress: '', hasUnknown: true, raw: null };
	}
}

// Tracks the resolve() of any in-flight verifyAddressOverridable() Promise, keyed by
// modal element id, so a second concurrent call for the same modal can settle the
// first one instead of leaving it permanently unresolved.
const _verifyAddressInFlight = new Map();

async function verifyAddressOverridable({ address = '', name = '', sanitize = null, currentValue = '', ids = {}, onAccept = null, onKeep = null } = {}) {
	// Centralized "suggestion, not a blocker" address-override helper.
	// Runs geocodeAddress() and, if a shared modal exists on the page, lets the
	// investor either accept the suggested address or explicitly keep what they
	// typed. We never silently overwrite the user's entry - only onAccept's
	// caller does that, and only after an explicit click.
	//
	// ids (all optional, defaults shown) let a page use non-default element ids:
	//   { modal: 'addressModal', heading: 'resultAddressHeading', message: 'resultAddress',
	//     cancelBtn: 'cancelAddress', proceedBtn: 'proceedAddress' }
	//
	// onAccept(out): called only if the user clicks "Use Suggested Address"
	// onKeep(out):   called if the user keeps their own entry - either because
	//                geocoding found nothing better, or they chose to override
	//
	// Returns a Promise<{ accepted: boolean, out: <geocodeAddress result> }> so
	// callers that need to block on the user's decision (e.g. before submitting
	// a form) can `await` it; callers that just want to react to focusout can
	// ignore the returned promise and rely on onAccept/onKeep instead.

	const elIds = {
		modal: 'addressModal',
		heading: 'resultAddressHeading',
		message: 'resultAddress',
		cancelBtn: 'cancelAddress',
		proceedBtn: 'proceedAddress',
		...ids,
	};

	const out = await geocodeAddress({ address, name, sanitize });

	const typedNormalized = (currentValue || address || '').toString().replace(/ +/g, '+');
	const hasSuggestion = out.ok && !out.hasUnknown && out.resultAddress && out.resultAddress.replace(/ +/g, '+') !== typedNormalized;
	const addressAlreadyGood = out.ok && !out.hasUnknown && !hasSuggestion;

	if (addressAlreadyGood) {
		// Geocoding confirms the typed address as-is - nothing to ask the user about.
		// If an earlier call for this same modal is still waiting on a click, settle
		// it now rather than leaving it pending indefinitely.
		const priorResolve = _verifyAddressInFlight.get(elIds.modal);
		if (priorResolve) {
			_verifyAddressInFlight.delete(elIds.modal);
			priorResolve({ accepted: false, out: null, superseded: true });
		}
		if (onKeep) onKeep(out);
		return { accepted: false, out };
	}

	return new Promise((resolve) => {
		// If an earlier, still-pending call for this same modal exists, resolve it now
		// instead of leaving it to hang forever once we rebind the shared modal's
		// buttons out from under it below (which would otherwise orphan its Promise).
		const priorResolve = _verifyAddressInFlight.get(elIds.modal);
		if (priorResolve) priorResolve({ accepted: false, out: null, superseded: true });
		_verifyAddressInFlight.set(elIds.modal, resolve);

		const finish = (accepted) => {
			_verifyAddressInFlight.delete(elIds.modal);
			try {
				const modalEl = document.getElementById(elIds.modal);
				if (modalEl && window.M?.Modal) M.Modal.getInstance(modalEl)?.close();
			} catch (e) {
				console.error(e);
			}
			if (accepted && onAccept) onAccept(out);
			if (!accepted && onKeep) onKeep(out);
			resolve({ accepted, out });
		};

		const modalEl = document.getElementById(elIds.modal);
		const headingEl = document.getElementById(elIds.heading);
		const messageEl = document.getElementById(elIds.message);
		let cancelEl = document.getElementById(elIds.cancelBtn);
		let proceedEl = document.getElementById(elIds.proceedBtn);

		if (!modalEl || !headingEl || !messageEl || !proceedEl || !window.M?.Modal) {
			// No modal wired up on this page - don't block anything, just report the result.
			finish(false);
			return;
		}

		if (hasSuggestion) {
			headingEl.innerHTML = 'We found a suggested<br>address, city, ST&ensp;ZIP';
			messageEl.innerHTML = out.resultAddress;
			proceedEl.style.display = '';
			proceedEl.textContent = 'Use Suggested Address';
		} else {
			headingEl.innerHTML = 'We could not verify this address';
			messageEl.innerHTML = 'You can keep the address you entered, or edit it above and we will check again.';
			proceedEl.style.display = 'none';
		}

		// Re-bind fresh button nodes on every call so repeated (e.g. focusout-triggered)
		// invocations never stack duplicate click handlers on the same DOM node.
		if (cancelEl) {
			const freshCancel = cancelEl.cloneNode(true);
			cancelEl.replaceWith(freshCancel);
			cancelEl = freshCancel;
			cancelEl.style.display = '';
			cancelEl.textContent = 'Keep My Entry';
			cancelEl.onclick = (e) => {
				e.preventDefault();
				finish(false);
			};
		}

		const freshProceed = proceedEl.cloneNode(true);
		proceedEl.replaceWith(freshProceed);
		proceedEl = freshProceed;
		if (hasSuggestion) {
			proceedEl.onclick = (e) => {
				e.preventDefault();
				finish(true);
			};
		}
		// else: no suggestion to accept - the button is hidden above and left with
		// no click handler, so a synthetic Enter-key click (existing per-page
		// keydown handlers dispatch a click on #proceedAddress whenever this modal
		// is open) can't silently accept blank/unknown geocode data.

		const modalInstance = M.Modal.getInstance(modalEl);
		// Force an explicit choice - Escape/outside-click must not be able to leave
		// this promise (and any caller awaiting it) unresolved forever. Only do this
		// when a click handler actually exists to close the modal (cancelEl, or a
		// proceedEl wired up above) - otherwise leave it dismissible so the investor
		// isn't ever trapped with no way to close it.
		const hasClosablePath = Boolean(cancelEl) || hasSuggestion;
		if (modalInstance && hasClosablePath) modalInstance.options.dismissible = false;
		modalInstance.open();
	});
}

async function export_table_to_excel(tablename, filename, options = {}) {
	// #6343: `false` suppresses the Count/Sum/Avg row for callers that own their own totals
	// (a custom report configuring totals.grandTotal). undefined keeps the legacy behaviour.
	const { includeTotalsRow } = options;
	const keepEmptyHeaders = new Set(options.keepEmptyHeaders || []); // kept even when every cell is blank
	// Lazy load ExcelJS
	if (!window.ExcelJS) {
		try {
			await window.loadExcelJS();
		} catch (err) {
			M.toast({ html: 'Failed to load Excel export library. Please try again.' });
			console.error('ExcelJS loading failed:', err);
			return;
		}
	}

	if (window.analytics) {
		window.analytics.track('Table Exported to Excel', {
			userEmail: authedUser,
			workspace: client,
			tableName: tablename,
			fileName: filename,
		});
	}

	const tableArray = tablename.split('|'); // Split tablename into an array of table IDs
	const workbook = new ExcelJS.Workbook(); // Create a new workbook
	const sheetDataArray = []; // Array to store data and metadata for sorting
	const usedSheetNames = new Set(); // Track unique worksheet names

	const CENTER_ALIGN_COLUMNS = new Set([
		'Class',
		'Classes',
		'Fund',
		'Funds',
		'KYC Status',
		'Rule of 72?',
		labelIdNumber(),
		'Price (basis)',
		'Exact Price',
		'Reference Price',
		'Qty * Exact Price',
		'Qty * Ref. Price',
		'Obs Count',
		'Alias Count',
		'Doc Count',
		'Award Year',
		'Method',
	]);

	const DATE_COLUMNS = new Set([
		'Date',
		'DOB',
		'Termination Date',
		'Birth Date',
		'Grant Date',
		'Issue Date',
		'Vesting Date',
		'Expiration Date',
		'Last Seen',
		'Invited',
	]);

	const TEXT_COLUMNS = new Set([
		'Cert #',
		'Sender Cert #',
		'Receiver Cert #',
		'Sender',
		'Sender Email',
		'Receiver',
		'Receiver Email',
		labelIdNumber(),
		'Name',
		'User Name',
		'Friendly Name',
		'InvestorId',
		'Notes',
		'Account Name',
		'Mailing Address',
		'Address Line 1',
		'Address 1',
		'Address 2',
		'City, ST ZIP',
		'Phone Number',
		'Status',
		'Class',
		'Classes',
		'Tranche',
		'Fund',
		'Funds',
		'Tags',
		'Description',
		'Num',
		'#',
		'Note',
		'Observers (other users who can see this account)',
		'Aliases (other accounts that this user can see)',
		'Routing Number',
		'Account Number',
		'ABA Number',
		'Further Credit Number',
		'Swift Code',
		'Intermediary IBAN',
		'Vesting Name',
		'Bank Acct Name',
		'2nd Bank Acct Name',
		'Checking Account',
		'Award Year',
		'Postal Code',
		'Tax ID',
		'SSN/EIN',
		'Founder No.',
		'Family No.',
		'Member No.',
		'Fnd',
		'Write-In Name(s)',
		'Vendor Code',
		'SH Number',
		'ST Number',
		'Shareholder Number',
		'Line Number',
		// #6333: mostly-numeric block IDs (1, 2, 3…) with a text "Total" row mixed in --
		// without this, the column reads as numeric (any numeric cell flags the whole
		// column) and the "Total" cell's Number("Total") = NaN gets written as ''.
		'Block #',
	]);

	const AVERAGE_COLUMNS = new Set(['Balance', 'Cost Basis', 'Exact Basis', 'Tax Basis', 'Tax Basis *', 'Days Held']);

	const INVALID_VALUES = new Set(['$NaN', '($NaN)', 'NaN', '(NaN)', '-NaN', '--', '-', 'undefined', 'null', 'na', 'n.a.']);

	const SKIP_TOTALS_SHEETS = new Set(['payout', 'reconciliation report']);

	const SKIP_PREFIXES = new Set([
		'reconciliation report',
		'new updated shareholders',
		'stock listing',
		'dividend report',
		'address labeling',
		'shareholder ownership',
		'l&l ownership rollup',
		'equity rollup',
	]);

	// Helper function to refine sheet names
	function refineSheetName(tableId) {
		// Extract date pattern (MM-DD-YYYY or MM-DD-YY) and convert to MM-DD-YY format
		const datePattern = /(\d{2}-\d{2}-\d{2,4})/;
		const dateMatch = tableId.match(datePattern);

		if (dateMatch) {
			let dateStr = dateMatch[1];
			// Convert YYYY to YY if needed
			if (dateStr.length === 10) {
				const parts = dateStr.split('-');
				dateStr = `${parts[0]}-${parts[1]}-${parts[2].substring(2)}`; // Convert to MM-DD-YY
			}
			// Preserve report name prefix before date for proper totals skipping
			const prefix = tableId.substring(0, dateMatch.index).replace(/Table/g, '').trim();
			if (prefix) {
				return `${prefix} ${dateStr}`;
			}
			return dateStr;
		}

		// Fallback to original logic if no date found
		return tableId
			.replace(/^user/, '') // Remove leading "user"
			.replace(/Sort/g, '') // Remove "Sort"
			.replace(/Table/g, '') // Remove "Table"
			.replace(/([a-z])([A-Z])/g, '$1 $2') // Insert spaces in camel case
			.replace(/^cap$/, 'Cap Table') // cap -> Cap Table
			.trim()
			.replace(/^([a-z])/, (m, ch) => ch.toUpperCase()); // Capitalize first word's first letter
	}

	// Helper function to clean invalid values, tabs, newlines, and extra spaces
	function cleanValue(value) {
		if (!value) return ''; // Handle null/undefined values
		value = String(value) // Ensure value is a string
			.replace(/[\x00-\x08\x0B\x0C\x0E-\x1F\x7F-\x9F]/g, '') // Remove XML-invalid control chars
			.replace(/[\t\r\n\u00A0]/g, ' ') // Replace tabs, newlines, and non-breaking spaces with a regular space
			.replace(/\s+/g, ' ') // Normalize multiple spaces to a single space
			.trim(); // Trim leading and trailing spaces
		return INVALID_VALUES.has(value) || value === '' ? '' : value; // Treat invalid or all-space values as empty
	}

	function sanitizeSheetName(rawName, fallback = 'Sheet') {
		const base = String(rawName || fallback)
			.replace(/[\x00-\x1F\x7F-\x9F]/g, '')
			.replace(/[:\\/?*\[\]]/g, ' ')
			.replace(/\s+/g, ' ')
			.trim()
			.replace(/^'+|'+$/g, '');
		return (base || fallback).substring(0, 31);
	}

	function makeUniqueSheetName(rawName) {
		let sanitized = sanitizeSheetName(rawName);
		if (!usedSheetNames.has(sanitized)) {
			usedSheetNames.add(sanitized);
			return sanitized;
		}
		let counter = 2;
		while (counter < 1000) {
			const suffix = ` (${counter})`;
			const nextName = sanitized.substring(0, Math.max(0, 31 - suffix.length)) + suffix;
			if (!usedSheetNames.has(nextName)) {
				usedSheetNames.add(nextName);
				return nextName;
			}
			counter++;
		}
		const fallback = `Sheet${Date.now()}`.substring(0, 31);
		usedSheetNames.add(fallback);
		return fallback;
	}

	// Normalize export dates and return a real Date object for Excel formatting.
	function parseDate(value, allowExcelSerial = false) {
		if (!value || String(value).includes('%')) return '';
		const raw = String(value).trim();
		if (!raw) return '';
		const normalized = normalizeDateString(raw, !allowExcelSerial);
		if (!normalized) return '';
		const m = moment.utc(normalized, 'YYYY-MM-DD', true);
		return m.isValid() ? m.toDate() : '';
	}

	/*
	function looksLikeDate_OLD(value) {
		if (!value || String(value).includes('%')) return false;

		const raw = String(value).trim();
		if (!raw) return false;

		// Smart detection must not treat pure numbers as dates.
		// Known DATE_COLUMNS are handled separately by parseDate(..., true).
		if (/^\d+(\.\d+)?$/.test(raw.replace(/,/g, ''))) return false;

		// Require obvious date syntax or month text.
		if (
			!/[/-]/.test(raw) &&
			!/\bjan(?:uary)?|feb(?:ruary)?|mar(?:ch)?|apr(?:il)?|may|jun(?:e)?|jul(?:y)?|aug(?:ust)?|sep(?:t(?:ember)?)?|oct(?:ober)?|nov(?:ember)?|dec(?:ember)?\b/i.test(
				raw
			)
		) {
			return false;
		}

		return !!normalizeDateString(raw, true);
	}
	*/

	function looksLikeDate(value) {
		if (value == null) return false;

		const str = String(value).trim();
		if (!str) return false;

		// Definitely not dates.
		if (str.includes('@')) return false;

		// Only send plausibly date-shaped strings to the date normalizer.
		const dateLike =
			/^\d{4}[-/]\d{1,2}[-/]\d{1,2}(?:[T\s].*)?$/.test(str) || // 2026-07-10
			/^\d{1,2}[-/]\d{1,2}[-/]\d{2,4}(?:\s.*)?$/.test(str) || // 7/10/2026
			/^[A-Za-z]{3,9}\s+\d{1,2},?\s+\d{4}(?:\s.*)?$/.test(str); // Jul 10, 2026

		if (!dateLike) return false;

		return !!normalizeDateString(str);
	}

	// Function to clean the first column by removing the email if it matches the second column
	function stripEmailFromName(rows, validColumns) {
		// Ensure there are at least two valid columns to work with
		if (validColumns.length < 2) return;

		const firstValidColIndex = validColumns[0]; // Index of the first valid column
		const secondValidColIndex = validColumns[1]; // Index of the second valid column

		for (let i = 1; i < rows.length; i++) {
			const firstColCell = rows[i].cells[firstValidColIndex];
			const secondColCell = rows[i].cells[secondValidColIndex];

			if (firstColCell && secondColCell) {
				const firstColText = firstColCell.innerText.trim();
				const secondColText = secondColCell.innerText.trim();

				// Check if the second column contains a valid email
				if (typeof validator !== 'undefined' && validator.isEmail(secondColText)) {
					// Create a regex to find the email in the first column
					const emailRegex = new RegExp(`\\b${secondColText}\\b`, 'i');

					// Remove the email from the first column if found
					const cleanedText = firstColText.replace(emailRegex, '').trim();
					firstColCell.innerText = cleanedText; // Update the first column's text
				}
			}
		}
	}

	function getExcelColumnLetter(index) {
		// Convert 0-based index to Excel column letters (e.g., 0 -> A, 26 -> AA)
		let letter = '';
		while (index >= 0) {
			letter = String.fromCharCode((index % 26) + 65) + letter;
			index = Math.floor(index / 26) - 1;
		}
		return letter;
	}

	tableArray.forEach((tableId) => {
		const table = document.getElementById(tableId);
		if (!table) return;

		// Clone the table
		let newTable = table.cloneNode(true);

		// Remove unwanted elements
		const UNWANTED_CLASSES = ['shareholder-initials', 'edit-transaction', 'edit-valuation', 'select-event', 'update_link', 'name-email'];
		UNWANTED_CLASSES.forEach((className) => {
			[...newTable.getElementsByClassName(className)].forEach((node) => node && node.remove());
		});

		let rows = newTable.rows;
		if (!rows.length) return;

		// Track valid columns for this sheet
		let validColumns = []; // Array to track valid column indices (non-blank header + non-empty data)

		// Determine valid columns
		let columnCount = rows[0].cells.length; // Total columns
		for (let j = 0; j < columnCount; j++) {
			// skip name-email column (doesn't work...)
			// if (rows[0].cells[j]?.hasAttribute("data-sort-default")) continue;

			const headerText = cleanValue(rows[0].cells[j]?.innerText || '');
			let hasData = false;

			// Check if the column has data
			for (let i = 1; i < rows.length; i++) {
				const cellText = cleanValue(rows[i].cells[j]?.innerText || '');
				if (cellText !== '') {
					hasData = true;
					break;
				}
			}

			// Keep the column if the header is not blank and it has data
			if (headerText !== '' && (hasData || keepEmptyHeaders.has(headerText))) {
				validColumns.push(j);
			}
		}

		stripEmailFromName(rows, validColumns); // Clean the name-email entries

		let sheetData = [];
		const subtotalExcelRows = new Set(); // #6343: Excel row numbers to exclude from the totals row
		let textColumns = new Set(); // Track text columns
		let dateColumns = new Set(); // Track date columns
		let numericColumns = new Set(); // Track numeric columns

		// First pass: classify known date/text columns from the header
		const headerCols = rows[0].querySelectorAll('td, th');

		validColumns.forEach((colIndex) => {
			const text = cleanValue(headerCols[colIndex]?.innerText || '');

			if (DATE_COLUMNS.has(text)) dateColumns.add(colIndex);
			else if (TEXT_COLUMNS.has(text)) textColumns.add(colIndex);

			// Cert / vendor / ID columns must stay text (avoid "10659, 13154" -> number)
			if (/cert\s*#|sender\s*cert|receiver\s*cert|shareholder\s*number|line\s*number|sender\s*id|receiver\s*id/i.test(text)) {
				textColumns.add(colIndex);
			}

			// Respect data-format attribute from custom cap table columns
			const dataFormat = headerCols[colIndex]?.getAttribute('data-format');
			if (dataFormat === 'date') {
				dateColumns.add(colIndex);
				textColumns.delete(colIndex);
			} else if (dataFormat && dataFormat !== 'number' && dataFormat !== 'currency' && dataFormat !== 'percent') {
				textColumns.add(colIndex);
			}
		});

		// Second pass: intelligently detect additional date columns from sample data
		validColumns.forEach((colIndex) => {
			if (dateColumns.has(colIndex) || textColumns.has(colIndex)) return;

			let checked = 0;
			let dateLike = 0;

			for (let r = 1; r < rows.length; r++) {
				if (rows[r].classList.contains('total-row')) continue;

				const cols = rows[r].querySelectorAll('td, th');
				const text = cleanValue(cols[colIndex]?.innerText || '');
				if (!text) continue;

				checked++;
				if (looksLikeDate(text)) dateLike++;

				if (checked >= 10) break;
			}

			if (checked >= 2 && dateLike / checked >= 0.8) dateColumns.add(colIndex);
		});

		// Process valid columns only
		for (let i = 0; i < rows.length; i++) {
			// Skip rows with the "total-row" class
			if (rows[i].classList.contains('total-row')) continue;

			let row = [];
			let cols = rows[i].querySelectorAll('td, th');

			validColumns.forEach((colIndex) => {
				let text = cleanValue(cols[colIndex]?.innerText || '');

				if (i === 0) {
					row.push(text);
					return;
				}

				// Data row
				if (dateColumns.has(colIndex)) {
					// Cells showing relative text ("3 months ago") carry the real timestamp in data-sort
					const sortVal = Number(cols[colIndex]?.getAttribute('data-sort'));
					row.push(parseDate(text, true) || (sortVal > 0 ? parseDate(sortVal, true) : ''));
					return;
				}

				if (textColumns.has(colIndex)) {
					// Process Class columns for <span class="share-tag">
					const spanTags = cols[colIndex]?.querySelectorAll('span.pill--gray');
					if (spanTags && spanTags.length > 0) {
						text = Array.from(spanTags)
							.map((span) => span.textContent.trim())
							.join(' | ');
					} else {
						text = cleanValue(cols[colIndex]?.innerText || '');
					}
					row.push(text);
					return;
				}

				// Comma-separated cert lists must remain text (e.g. "10659, 13154")
				if (/^\d[\d,\s]*$/.test(text) && text.includes(',')) {
					textColumns.add(colIndex);
					row.push(text);
					return;
				}

				// Handle values in parentheses or percentages
				let rawValue = text.replace(/[,$\s]/g, ''); // Remove commas, dollar signs, and spaces
				if (/^\(.*\)$/.test(rawValue) || /^\d+(\.\d+)?%$/.test(rawValue)) {
					numericColumns.add(colIndex);
				}

				let number = Number(rawValue);
				if (Number.isFinite(number) && text.trim() !== '') {
					numericColumns.add(colIndex);
					row.push(!rawValue ? '' : number);
				} else {
					row.push(text);
				}
			});

			// Ensure the row length matches the number of valid columns
			while (row.length < validColumns.length) {
				row.push('');
			}

			if (row.some((cell) => cell !== '')) {
				sheetData.push(row);
				// #6343: aggregate rows restate rows already in the sheet (e.g. a per-block
				// report's per-shareholder Total), so the totals row below must leave them out
				// or every value is counted twice. sheetData[0] is the header, so the row just
				// pushed is Excel row sheetData.length.
				if (rows[i].classList.contains('subtotal-row')) subtotalExcelRows.add(sheetData.length);
			}
		}

		// Process sheet data
		if (sheetData.length > 0) {
			sheetDataArray.push({
				sheetName: makeUniqueSheetName(refineSheetName(tableId)),
				sheetData,
				validColumns, // Pass validColumns for this specific sheet
				dateColumns: Array.from(dateColumns).sort((a, b) => a - b),
				numericColumns: Array.from(numericColumns).sort((a, b) => a - b),
				textColumns: Array.from(textColumns).sort((a, b) => a - b),
				subtotalExcelRows: Array.from(subtotalExcelRows).sort((a, b) => a - b),
				rowCount: sheetData.length,
			});
		}
	});

	// Sort sheets by row count in descending order
	// sheetDataArray.sort((a, b) => b.rowCount - a.rowCount);

	// Helper to decide if totals row should be skipped for this sheet
	function shouldSkipTotals(sheetName) {
		const normalized = String(sheetName || '')
			.trim()
			.toLowerCase();

		// Exact matches
		if (SKIP_TOTALS_SHEETS.has(normalized)) return true;

		// Also skip if the sheet starts with a known prefix
		return Array.from(SKIP_PREFIXES).some((prefix) => normalized.startsWith(prefix));
	}

	// #6343: an Excel range covering rows firstRow..lastRow minus the excluded ones, as one or
	// more comma-separated ranges ("C2:C6,C8:C12"). Returns the plain range when nothing is
	// excluded, so exports without subtotal rows keep their existing single-range formulas.
	function buildRangeExpr(columnLetter, firstRow, lastRow, excludedRows) {
		if (!excludedRows || !excludedRows.size) return `${columnLetter}${firstRow}:${columnLetter}${lastRow}`;
		const parts = [];
		let start = firstRow;
		for (let r = firstRow; r <= lastRow; r++) {
			if (!excludedRows.has(r)) continue;
			if (start <= r - 1) parts.push(`${columnLetter}${start}:${columnLetter}${r - 1}`);
			start = r + 1;
		}
		if (start <= lastRow) parts.push(`${columnLetter}${start}:${columnLetter}${lastRow}`);
		return parts.join(',');
	}

	sheetDataArray.forEach(({ sheetName, sheetData, validColumns, dateColumns, numericColumns, textColumns = [], subtotalExcelRows = [] }) => {
		const worksheet = workbook.addWorksheet(sheetName);

		// Freeze the top row
		worksheet.views = [{ state: 'frozen', ySplit: 1 }];

		// Re-convert numericColumns and dateColumns to Set if needed
		const numericColumnsSet = new Set(numericColumns);
		const dateColumnsSet = new Set(dateColumns);

		if (!shouldSkipTotals(sheetName) && includeTotalsRow !== false) {
			// Add "Count/Total" row with formulas
			const lastDataRowIndex = sheetData.length; // Excel is 1-based indexing; add 1 for the header row
			const excludedRows = new Set(subtotalExcelRows);
			const totalsRow = ['Count/Sum/Avg']; // Start with label in the first column
			validColumns.forEach((colIndex, index) => {
				// console.log(index + 1, sheetData[0][index + 1])
				if (index == validColumns.length - 1) return; // Don't overshoot columns
				const columnLetter = getExcelColumnLetter(index + 1); // Adjust for the "Count/Total" label
				const rangeExpr = buildRangeExpr(columnLetter, 2, lastDataRowIndex, excludedRows);
				if (!rangeExpr) {
					// Every data row was excluded -- SUM() with no range is not a valid formula.
					totalsRow.push(0);
					return;
				}
				if (numericColumnsSet.has(validColumns[index + 1])) {
					if (Array.from(AVERAGE_COLUMNS).some((keyword) => sheetData[0][index + 1]?.startsWith(keyword))) {
						// Insert AVG formula for Balance columns
						totalsRow.push({ formula: `AVERAGE(${rangeExpr})` });
					} else {
						// Insert SUM formula for numeric columns
						totalsRow.push({ formula: `SUM(${rangeExpr})` });
					}
				} else if (excludedRows.size) {
					// ROW()-COUNTBLANK(...) below assumes one contiguous block ending just above
					// this row, which no longer holds once subtotal rows are carved out (#6343).
					totalsRow.push({ formula: `COUNTA(${rangeExpr})` });
				} else {
					// Insert COUNTBLANK formula for non-numeric columns
					totalsRow.push({ formula: `ROW()-COUNTBLANK(${columnLetter}2:${columnLetter}${lastDataRowIndex})-2` });
				}
			});

			sheetData.push(totalsRow);
		}

		// Formatting
		sheetData.forEach((row, rowIndex) => {
			while (row.length < validColumns.length) row.push(''); // Fill missing cells with empty strings
			const excelRow = worksheet.addRow(row);

			if (rowIndex === 0) {
				// Style the header row
				excelRow.eachCell((cell, colIndex) => {
					const mappedColIndex = validColumns[colIndex - 1]; // Map to validColumns index
					cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'EBF1DE' } };
					cell.font = { bold: true };
					cell.border = {
						top: { style: 'thin' },
						left: { style: 'thin' },
						bottom: { style: 'thin' },
						right: { style: 'thin' }, // Ensure rightmost border
					};
					if (CENTER_ALIGN_COLUMNS.has(cell.value)) {
						cell.alignment = { horizontal: 'center' };
					} else {
						cell.alignment = { horizontal: 'left' };
					}
				});
			} else {
				excelRow.eachCell((cell, colIndex) => {
					const mappedColIndex = validColumns[colIndex - 1]; // Map to validColumns index
					const cellData = row[colIndex - 1]; // Use row indices directly
					let rawValue = String(cellData);
					// Only bold the last row if totals are not skipped (i.e., it's a totals row)
					const isLastRow = rowIndex === sheetData.length - 1;
					const shouldBoldLastRow = isLastRow && !shouldSkipTotals(sheetName);
					if (shouldBoldLastRow) {
						// Bottom row (footer/totals row)
						if (cellData && typeof cellData === 'object' && cellData.formula) {
							// Set the formula
							cell.value = { formula: cellData.formula };
							if (dateColumnsSet.has(mappedColIndex)) {
								cell.numFmt = '#,##0';
								cell.alignment = { horizontal: 'center' };
							} else if (numericColumnsSet.has(mappedColIndex)) {
								// Borrow formatting from the cell above
								const rowAbove = worksheet.getRow(rowIndex);
								const cellAbove = rowAbove.getCell(colIndex);
								if (cellAbove) {
									cell.numFmt = cellAbove.numFmt;
									cell.alignment = cellAbove.alignment;
								} else {
									// Default formatting if no cell above
									cell.alignment = { horizontal: 'right', indent: 1 };
								}
							} else {
								// Text-based column
								cell.numFmt = '#,##0'; // Integer
								cell.alignment = { horizontal: 'left' };
							}
						}
						cell.font = { bold: true };
					} else if (numericColumnsSet.has(mappedColIndex)) {
						if (/^\(\$?.*\)$/.test(rawValue)) {
							// Convert accounting-style string to a negative number
							const numericValue = Number(`-${rawValue.replace(/[,$\s]/g, '').slice(1, -1)}`);
							cell.value = !rawValue ? '' : numericValue; // Store the numeric value
							// GH: match on-screen decimals (WYSIWYG) -- was hard-coded to 2, showing (28,821.1673) as (28,821.17).
							const negDecimals = (rawValue.match(/\.(\d+)/)?.[1] || '').length;
							const negDigits = negDecimals ? `0.${'0'.repeat(negDecimals)}` : '0';
							cell.numFmt = `#,##${negDigits}_);[Red](#,##${negDigits})`; // Red parentheses format for negatives
						} else {
							// Handle other numeric values, including percentages
							let numericValue = Number(rawValue.replace(/[–—−]/g, '-').replace(/[,$\s%]/g, '')); // Remove $, spaces, and % for parsing
							if (rawValue.includes('%')) {
								numericValue /= 100; // Convert percentage to fractional value
							}
							cell.value = !rawValue || !Number.isFinite(numericValue) ? '' : numericValue; // Store only finite numeric values
							const decimalPlaces = rawValue.includes('.') ? rawValue.split('.')[1].replace('%', '').length : 0;
							cell.numFmt = rawValue.includes('%')
								? decimalPlaces === 0
									? '0%' // Percentage format with no decimals
									: `0.${'#'.repeat(decimalPlaces)}%` // Percentage format with decimals
								: decimalPlaces === 0
									? '#,##0' // Regular number format with no decimals
									: `#,##0.${'#'.repeat(decimalPlaces)}`; // Regular number format with decimals
						}
						cell.alignment = { horizontal: 'right', indent: 1 }; // Right-align numeric cells
					} else if (dateColumnsSet.has(mappedColIndex)) {
						cell.value = cellData;
						cell.numFmt = 'mmm d, yyyy'; // or 'yyyy-mm-dd' or 'mmmm d, yyyy' if preferred
						cell.alignment = { horizontal: 'center' };
					} else {
						// Default alignment for text
						cell.value = cellData;
						// Check if this column header is in CENTER_ALIGN_COLUMNS
						const headerValue = sheetData[0] && sheetData[0][colIndex - 1] ? String(sheetData[0][colIndex - 1]) : '';
						if (CENTER_ALIGN_COLUMNS.has(headerValue)) {
							cell.alignment = { horizontal: 'center' };
						} else {
							cell.alignment = { horizontal: 'left' };
						}
					}
				});
			}
		});

		// Create a mapping of valid columns after empty columns are removed
		const validColumnMap = validColumns.reduce((map, originalIndex, newIndex) => {
			map[originalIndex] = newIndex;
			return map;
		}, {});

		// Column Width Adjustments
		worksheet.columns.forEach((column, colIndex) => {
			// Map the current column index to the original index
			const originalIndex = validColumns[colIndex]; // Map to the original column index in the table

			if (originalIndex === undefined) return; // Skip if no valid mapping exists for this column

			const headerValue = sheetData[0]?.[colIndex] || ''; // Get the header value for the column

			// Center-align explicitly defined columns, regardless of other categorization
			if (CENTER_ALIGN_COLUMNS.has(headerValue)) {
				column.alignment = { horizontal: 'center' }; // Center-align
				if (dateColumnsSet.has(originalIndex)) {
					column.width = 16; // Fixed width for Date columns
				} else {
					// Adjust width based on content length for center-aligned columns
					column.width = Math.max(
						...sheetData.map((row) => (row[colIndex] || '').toString().length + 2),
						headerValue.length + 2, // Ensure header fits
						10 // Minimum width of 10
					);
				}
			} else if (numericColumnsSet.has(originalIndex)) {
				// Handle numeric columns
				column.width = Math.max(
					...sheetData.map((row) => (row[colIndex] || '').toString().length + 4),
					10 // Minimum width of 10
				);
				column.alignment = { horizontal: 'right', indent: 1 }; // Right-align numeric data
			} else if (dateColumnsSet.has(originalIndex)) {
				// Handle date columns
				column.width = Math.max(headerValue.length + 2 || 10, 14); // Minimum width of 14
				column.alignment = { horizontal: 'center' }; // Center-align date data
			} else {
				// Default case: Adjust width based on content length, with a minimum and maximum width
				const maxLength = Math.max(
					...sheetData.map((row) => (row[colIndex] || '').toString().length + 2),
					10 // Minimum width of 10
				);
				column.width = Math.min(maxLength, 75); // Cap width at 75
				column.alignment = { horizontal: 'left' }; // Left-align text columns by default
			}
		});
	});

	// Guard against creating an invalid workbook with zero worksheets.
	// This can happen when all values are empty/invalid after cleanup.
	if (workbook.worksheets.length === 0) {
		const worksheet = workbook.addWorksheet('Export');
		worksheet.addRow(['No exportable data was found for this table.']);
	}

	// Export the workbook
	const buffer = await workbook.xlsx.writeBuffer();
	saveAs(
		new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }),
		filename.replace(/(\.[\w]{2,5})?$/, '') + '.xlsx'
	);
}

async function download_csv(csv, filename, convertToExcel = true) {
	if (!csv) {
		alert('No data to export.');
		return;
	}
	// Split by newline and filter out empty lines
	const rows = csv.trim().split(/\r?\n/).filter(Boolean);
	if (rows.length <= 1) {
		alert('CSV must have more than one row.');
		return;
	}

	if (window.analytics) {
		window.analytics.track('CSV Export Redirected to Excel', {
			userEmail: authedUser,
			workspace: client,
			fileName: filename,
		});
	}

	let extension = filename.split('.').pop();
	if (!convertToExcel || extension == 'json') {
		// Handle JSON download
		const rawFile = new Blob([csv], { type: 'application/' + extension });
		const downloadLink = document.createElement('a');
		if (extension.startsWith('xls')) extension = 'csv';
		downloadLink.download = filename.replace(/(\.[\w]{2,5})?$/, '') + '.' + extension;
		downloadLink.href = window.URL.createObjectURL(rawFile);
		downloadLink.style.display = 'none';
		document.body.appendChild(downloadLink);
		downloadLink.click();
		document.body.removeChild(downloadLink);
	} else {
		// Parse the CSV using PapaParse
		const parsedData = Papa.parse(csv, { header: false, skipEmptyLines: true });

		// Create a temporary table element
		const tempTable = document.createElement('table');
		tempTable.id = filename.replace(/\s*\(.*\)\.\w+$/, '');

		// Populate table with parsed data
		parsedData.data.forEach((rowArray) => {
			const row = document.createElement('tr');
			rowArray.forEach((cellText) => {
				const cell = document.createElement('td');
				cell.textContent = cellText.trim(); // Add trimmed cell text
				row.appendChild(cell);
			});
			tempTable.appendChild(row);
		});

		// Append the table to the DOM temporarily
		document.body.appendChild(tempTable);
		await export_table_to_excel(tempTable.id, filename.replace(/\.csv$/, '.xlsx'));
		document.body.removeChild(tempTable);
	}
}

function itsTreasury(email = '', name = '') {
	email = email.toLowerCase();
	name = name.toLowerCase();
	const treasury = window.clientData.treasury_account;
	return (
		name.includes('treasury') || email.includes('treasury') || email.startsWith('corporate_') || email.startsWith('corporate-') || treasury?.includes(email)
	);
}

function normalizeDate(input, opts = {}) {
	// Requires moment.js and global dateFormats (array of patterns).
	// Returns "MM/DD/YYYY" or "" if unparseable / implausible.
	// Options:
	//   now: moment-compatible date to use as "today"
	//   minYear, maxYear: hard sanity bounds (default 1850–2050)
	//   kind: "generic" (default) or "birthdate"
	//   minAge, maxAge: only used if kind==="birthdate" or explicitly supplied
	//   disallowFuture: if true, reject future dates

	const now = opts?.now ? moment(opts.now) : moment();

	const minYear = opts?.minYear ?? 1850;
	const maxYear = opts?.maxYear ?? 2050;

	const kind = opts?.kind || 'generic';

	// Birthdates enforce age bounds by default
	const hasAgeBounds = kind === 'birthdate' || 'minAge' in opts || 'maxAge' in opts;

	const minAge = hasAgeBounds ? (opts.minAge ?? 0) : null;

	const maxAge = hasAgeBounds
		? (opts.maxAge ?? 200) // default 0–200 for birthdates
		: null;

	// Birthdates cannot be in the future (unless explicitly overridden)
	const disallowFuture = opts?.disallowFuture ?? kind === 'birthdate';

	if (input == null) return '';
	let s = String(input).trim();
	if (!s) return '';
	if (s === '-' || s === '.') return s; // pass-through

	// Clean weird chars and slashes (common in pasted data)
	s = s
		.replace(/[^\x20-\x7E]/g, '') // strip non-ASCII
		.replace(/[\u2044\u2215]/g, '/'); // normalize odd slash chars

	// Helper: check final moment against rules
	function acceptMoment(m) {
		if (!m || !m.isValid()) return false;
		const y = m.year();
		if (y < minYear || y > maxYear) return false;
		if (disallowFuture && m.isAfter(now)) return false;
		if (hasAgeBounds) {
			const age = now.diff(m, 'years', true);
			if (age < minAge || age > maxAge) return false;
		}
		return true;
	}

	// Excel serial? (simple, fast: positive int < 100000)
	const maybeNum = /^[0-9]+(?:\.\d+)?$/.test(s) ? Math.floor(Number(s)) : NaN;
	if (maybeNum > 0 && maybeNum < 100000) {
		const d1900 = moment.utc('1899-12-31').add(maybeNum >= 60 ? maybeNum - 1 : maybeNum, 'days'); // 1900 system
		const d1904 = moment.utc('1904-01-01').add(maybeNum, 'days'); // 1904 system

		const candidates = [d1900, d1904].filter((m) => {
			if (!m.isValid()) return false;
			const y = m.year();
			if (y < minYear || y > maxYear) return false;
			if (disallowFuture && m.isAfter(now)) return false;
			return true;
		});

		let mPick = null;
		if (candidates.length === 1) {
			mPick = candidates[0];
		} else if (candidates.length === 2) {
			// pick whichever is closer to "now"
			mPick = Math.abs(candidates[0].diff(now, 'days')) <= Math.abs(candidates[1].diff(now, 'days')) ? candidates[0] : candidates[1];
		}

		if (mPick && acceptMoment(mPick)) {
			return mPick.format('MM/DD/YYYY');
		}
		// else fall through to regular parsing
	}

	// Expand 2-digit year in numeric dates: 6/4/53 → 6/4/1953 or 6/4/2053
	let m2 = s.match(/^(\d{1,2})\/(\d{1,2})\/(\d{2})(?!\d)$/);
	if (m2) {
		const [, mo, da, yy] = m2;
		const y1900 = 1900 + +yy;
		const y2000 = 2000 + +yy;
		const nowYear = now.year();

		let candidates = [y1900, y2000].filter((y) => y >= minYear && y <= maxYear);
		let year;
		if (candidates.length === 1) {
			year = candidates[0];
		} else if (candidates.length === 2) {
			year = Math.abs(candidates[0] - nowYear) <= Math.abs(candidates[1] - nowYear) ? candidates[0] : candidates[1];
		} else {
			// Fallback — at least try 1900s
			year = y1900;
		}

		s = `${mo}/${da}/${year}`;
	}

	// Expand 2-digit year in D-MMM-YY: 4-Jun-53 → 4-Jun-1953/2053
	let m3 = s.match(/^(\d{1,2})[-\s]([A-Za-z]{3,})[-\s](\d{2})(?!\d)$/);
	if (m3) {
		const [, da, mon, yy] = m3;
		const y1900 = 1900 + +yy;
		const y2000 = 2000 + +yy;
		const nowYear = now.year();

		let candidates = [y1900, y2000].filter((y) => y >= minYear && y <= maxYear);
		let year;
		if (candidates.length === 1) {
			year = candidates[0];
		} else if (candidates.length === 2) {
			year = Math.abs(candidates[0] - nowYear) <= Math.abs(candidates[1] - nowYear) ? candidates[0] : candidates[1];
		} else {
			year = y1900;
		}

		s = `${da}-${mon}-${year}`;
	}

	// Final parse, using your global dateFormats
	let m = moment(s, dateFormats, false); // forgiving for CSVs, strict on format list
	if (!acceptMoment(m)) return '';
	return m.format('MM/DD/YYYY');
}

function labelIdNumber() {
	return window.clientData.language?.label_id_number || 'Id Number';
}

function sendAlert(subject, message) {
	if (window.analytics)
		window.analytics.track('Alert Sent', {
			userEmail: authedUser,
			workspace: client,
			alertSubject: subject,
		});

	axios
		.post(
			'https://api.nthround.io/portal/auth/send-email',
			JSON.stringify({
				userid: authedUser,
				client: client,
				cookie: window.cookie,
				subject: subject,
				message: message,
				is_admin_alert: true,
			})
		)
		.then((response) => {
			console.log(response);
		})
		.catch(function (error) {
			console.error(error);
		});
}

// 5-27-2024 This seems obsolete and broken.
function send_dashboard_request() {
	console.log('Sending failed sign in notice.');
	async_lambda(
		'https://oxx4gukklc.execute-api.us-east-1.amazonaws.com/presigned-exec/AQICAHjyZmzK8d2PGyyv1Zve93nUW1AyRl9VZtdIMbp8zlT_-QFah2mlo1elrLiM2SpRi4qIAAAA9zCB9AYJKoZIhvcNAQcGoIHmMIHjAgEAMIHdBgkqhkiG9w0BBwEwHgYJYIZIAWUDBAEuMBEEDF5ObHnjCeKCjlPFxQIBEICBr76RMdhEz1TzquhWdpohactYdW12Fu0EmYjj1Xzg8MpzQsR19TauxoaQSya6nhv2JeQdF6iw9UP3T0-Po0hE-iMuDc4259GVI0_PyA7AG3voxG0yk2ufS_w6zK2Qsag3p94btomC3Sj5DAO4T07ScYkyDQfZQ-0j6jF7Gy3dMVqEtPiwoC9q01MKr7zXIExjQx8sp-J1BKk9YOsGD4uZv50hLfg29x4SdhUdKSDksm8=',
		{
			client: client,
			userid: window.requestEmail,
		}
	).then((response) => console.log('Sent dashboard request, no errors. ', response).catch((err) => console.err('PROBLEM SENDING DASHBOARD REQUEST: ', err)));
}

function async_lambda(url, params) {
	return axios.post(url, Object.assign(params, { 'io.nthround.env': env }));
}

function deleteCookie(name) {
	const baseDomain = location.hostname === 'localhost' ? '' : `; domain=.${location.hostname.split('.').slice(-2).join('.')}`;

	document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT${baseDomain}; path=/`;
	document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/`;
}

function getCookie(cname = 'nth.IdToken') {
	let name = cname + '=';
	let decodedCookie = decodeURIComponent(document.cookie);
	let ca = decodedCookie.split(';');
	for (let i = 0; i < ca.length; i++) {
		let c = ca[i];
		while (c.charAt(0) == ' ') {
			c = c.substring(1);
		}
		if (c.indexOf(name) == 0) {
			return c.substring(name.length, c.length);
		}
	}
	return '';
}

function checkCookie(cname) {
	let match = document.cookie.match(new RegExp('(^| )' + cname + '=([^;]+)'));
	return match;
}

async function checkCookieWithRetry(cname, maxRetries = 3, delayMs = 100) {
	for (let attempt = 0; attempt < maxRetries; attempt++) {
		const cookieExists = checkCookie(cname);
		if (cookieExists) {
			if (attempt > 0) {
				console.log(`Cookie ${cname} found on attempt ${attempt + 1}`);
			}
			return false; // Cookie exists
		}

		// Wait before next attempt (except on last attempt)
		if (attempt < maxRetries - 1) {
			await new Promise((resolve) => setTimeout(resolve, delayMs));
		}
	}

	// Cookie not found after all retries
	return true; // No cookies found
}

async function checkAuth() {
	window.authType = null;
	window.cookie = getCookie();
	window.authenticated = false;
	let authRedirect = '/signin/';
	// if (currentlyRaising) authRedirect = '/join/';

	// Retry cookie check with delays to prevent premature clearing
	// Cookies may not be immediately available on page load
	let noCookies = await checkCookieWithRetry('nth.userid', 1, 100);

	console.log('checkAuth: pn=' + pn + ' noCookies=' + noCookies + ' hasIdToken=' + !!window.cookie + ' hasMfaPending=' + !!checkCookie('nth.MfaPending'));

	// Only clear sessionStorage if cookies are truly missing AND we're not on a public page
	// Also check if we have valid session data - if so, don't clear (might be a race condition)
	if (noCookies && !pn.includes('/signin') && !pn.includes('/join') && !pn.includes('/forms')) {
		// Check if we have valid session data that suggests user was authenticated
		const hasValidSessionData = sessionStorage.getItem(client + '.Data') || sessionStorage.getItem('user.Data') || sessionStorage.getItem('user.Auth');

		if (!hasValidSessionData) {
			// No cookies AND no session data - safe to clear
			sessionStorage.clear();
			console.log('Cleared sessionStorage: no cookies and no valid session data');
		} else {
			// We have session data but no cookies - might be a race condition
			// Log it but don't clear - let the auth flow handle it
			console.warn('Cookie check failed but session data exists - possible race condition, not clearing sessionStorage');
		}
	}

	if (pn.includes('/signin') || pn.includes('/join') || pn.includes('/forms')) {
		if (window.location.href.includes('?failure=link-expired')) {
			if (noCookies) {
				alert('Sorry, that authlink has expired.  Please try signing in again.  Thank you!');
			} else {
				console.log('Redirecting for clicking expired authlink.');
				console.log('Redirecting - checkAuth 1');
				// handle path, if there is one
				let newPath = window.location.href.replace(/.*&path=/, '');
				window.location.replace(newPath ? newPath : '/');
				return;
			}
		} else if (window.requestEmail) {
			console.log('Request email = ' + window.requestEmail);
		} else if (!noCookies) {
			console.log('May be authed in already');
		} else return 'Must sign in';
	}

	if (noCookies) {
		console.log('No IdToken found.');
		window.authType = 'unauthorized';
		window.authenticated = false;
		// Updated 4-27-2024
		if (pn != authRedirect) {
			console.log('checkAuth: redirecting to ' + authRedirect + ' (no nth.userid cookie, pn=' + pn + ')');
			window.location.replace(authRedirect);
		} else {
			console.log('checkAuth: redirecting to /signin/ (no nth.userid cookie, already at authRedirect=' + authRedirect + ')');
			window.location.replace('/signin/');
		}
		return;
	}

	// Native Cognito MFA: magic-link login withheld nth.IdToken and set nth.MfaSession /
	// nth.MfaPending instead — no JWT exists yet for this session. Calling verify-decode-jwt
	// with an empty cookie here would misread as "UserId mismatch" and sign the user out.
	// Reuse the existing 6-digit verify modal (the same one already built for the legacy
	// custom:Authenticator == 'SignIn' case) to complete the challenge — the browser
	// auto-attaches nth.MfaSession to that call — then re-run checkAuth() once a real JWT
	// cookie exists.
	if (!window.cookie && checkCookie('nth.MfaPending')) {
		console.log('Native MFA challenge pending.');
		window.authenticatorValue = 'SignIn';
		document.addEventListener(
			'authenticatorComplete',
			function onNativeMfaChallengeComplete() {
				document.removeEventListener('authenticatorComplete', onNativeMfaChallengeComplete);
				sessionStorage.removeItem('user.Auth');
				checkAuth();
			},
			{ once: true }
		);
		document.dispatchEvent(new Event('scaffoldAuthenticatorModals'));
		return;
	}

	let userAuth = JSON.parse(sessionStorage.getItem('user.Auth'));
	if (userAuth) {
		doUserAuth(userAuth);
	} else {
		axios
			.get(urlBase + '/auth/verify-decode-jwt', {
				params: {
					client: client,
					cookie: window.cookie,
					host: window.location.host,
				},
				withCredentials: window.cookie ? false : true,
			})
			.then(function (res) {
				sessionStorage.setItem('user.Auth', JSON.stringify(res.data));
				doUserAuth(res.data);
			})
			.catch(function (err) {
				console.error(err);
				console.log('Redirecting for Axios CORS error.');
				alert('Axios CORS error.');

				// Too harsh if just an Internet problem ???
				signOut('verify-decode-jwt request failed: ' + err);
				window.location.replace('/signin/');

				return err;
			});
	}

	function doUserAuth(data) {
		//console.log(res);
		// let data = res['data'];
		let userName = data['name'];
		let userEmail = data['email'];
		let cognitoId = data['nth_username'] || data['cognito:username'];
		if (!cognitoId || cognitoId != authedUser) {
			console.log('UserId mismatch. cognitoId=' + cognitoId + ' authedUser=' + authedUser);
			signOut('UserId mismatch: cognitoId=' + cognitoId + ' authedUser=' + authedUser);
			alert('UserId mismatch.');
			return 'UserId mismatch.';
		}
		if (window.requestEmail && window.requestEmail != authedUser) {
			console.log('Request email mismatch. requestEmail=' + window.requestEmail + ' authedUser=' + authedUser);
			signOut('Request email mismatch: requestEmail=' + window.requestEmail + ' authedUser=' + authedUser);
			alert('Request email mismatch.');
			return 'Request email mismatch.';
		}

		let userGroups = data['cognito:groups']; // <-- not used
		let carlist1 = data['custom:ClientAccessRights1'];
		let carlist2 = data['custom:ClientAccessRights2'];
		let carlist = carlist1 + (carlist2 ? ',' + carlist2 : '');
		let cars = carlist.split(',');

		if (cars.indexOf('^' + client) >= 0) {
			window.authType = 'admin';
			window.authenticated = true;
		} else if (cars.indexOf(client) >= 0) {
			window.authType = 'user';
			window.authenticated = true;
		} else {
			window.authType = 'unauthorized';
			window.authenticated = false;
		}
		console.log('checkAuth: authType=' + window.authType + ' for client=' + client);

		if (window.authType != 'admin') {
			window.blurNames = null;
			sessionStorage.removeItem('blurnames');
		}

		let nowTime = new Date();
		let authTime = new Date(data['auth_time'] * 1000);
		let expiration = new Date(data['exp'] * 1000);
		let oneWeek = new Date((data['exp'] + 604800) * 1000);
		let oneMonth = new Date((data['exp'] + 2592000) * 1000);
		if (nowTime > oneMonth) {
			// oneWeek) {
			console.log('Authentication expired. now=' + nowTime + ' oneMonth=' + oneMonth);
			signOut('Authentication expired: now=' + nowTime + ' oneMonth=' + oneMonth);
			return 'Authentication expired.';
		}
		if (nowTime < authTime.setMinutes(authTime.getMinutes() + 10)) {
			console.log('New tokens - run Authenticator??');
		}

		window.authenticatorValue = data['custom:Authenticator'];
		// 3/23/2024 moved here fron index.js
		async function authenticateIfNeeded() {
			// Create a promise that resolves when the authentication is complete
			const waitForAuthenticator = new Promise((resolve, reject) => {
				document.addEventListener(
					'authenticatorComplete',
					() => {
						resolve();
					},
					{ once: true }
				); // 'once: true' ensures the listener is removed after it's invoked once
			});

			setTimeout(async () => {
				document.dispatchEvent(new Event('scaffoldAuthenticatorModals'));
				await waitForAuthenticator;
				carryOnLoading();
			}, 50);
		}

		function carryOnLoading() {
			if (window.authenticated) {
				// #5076: EXTERNAL_DATA clients load transactions from a CSV client-side.
				// Pages that overwrite clientData in sessionStorage without preserving those
				// CSV-derived transactions (e.g. /trade polling at trade.js:4768) leave the
				// next page with a broken cache. Detect that specific broken-cache state and
				// trigger the refresh so getStandardTransactionsFromFile rehydrates.
				// Narrower than the reverted cc7a8861b, which forced refresh on every
				// EXTERNAL_DATA page load regardless of cache state.
				//
				// Consolidated view (userid === 'consolidated.view') is excluded:
				// SessionStorageService's refresh only invokes the standard CSV loader,
				// which filters by userData.userid — for consolidated that filter matches
				// zero rows. Consolidated view's broken-cache scenario (#5018) needs its
				// own fix dispatching loadConsolidatedExternalTransactions instead.
				// Admin pages don't keep these transactions, and an account with none was already checked this session
				const cacheMissingExternalTxs =
					!pn.startsWith('/admin') &&
					window.userData?.userid !== 'consolidated.view' &&
					!!window.clientData?.transactions_data &&
					sessionStorage.getItem(window.client + '.NoExtTx') !== window.userData?.userid &&
					!Object.values(window.clientData.equity || {}).some((eq) => eq?.transactions?.length);

				// Consolidated view: the standard CSV loader filters by userData.userid
				// which is 'consolidated.view' and matches zero rows. Detect missing
				// consolidated transactions and dispatch a separate event so index.js
				// can call loadConsolidatedExternalTransactions instead (#5018).
				const consolidatedMissingTxs =
					window.userData?.userid === 'consolidated.view' &&
					!!window.clientData?.transactions_data &&
					!window.userData?.clients?.[window.client]?.consolidatedTransactions?.length;

				// Admin pages use the cap table saved this session; a reload (which clears it) or ?refresh=true fetches fresh
				const isReload = (performance.getEntriesByType('navigation')[0] || {}).type === 'reload';
				const needFreshCapTable =
					(pn.includes('/admin') && !NthUtil.sessionStore.hasCapTable(window.client)) || isReload || location.search.includes('refresh=true');
				if (
					(USE_PIN || window.USE_AUTHENTICATOR) &&
					(needFreshCapTable || !window.userData || !sessionStorage.getItem(window.client + '.Data') || cacheMissingExternalTxs)
				)
					// capTableOnly (admin): skip the account data if it's already here (loadCapTableOnly checks)
					// keepCapTable: account data only (e.g. CSV transactions to rehydrate), keep the saved cap table
					document.dispatchEvent(
						new CustomEvent('RefreshSessionStorage', { detail: { keepCapTable: !needFreshCapTable, capTableOnly: pn.includes('/admin') } })
					);

				if (consolidatedMissingTxs) document.dispatchEvent(new Event('RefreshConsolidatedTransactions'));

				document.dispatchEvent(new Event('AuthComplete'));
				if (pn.includes('/signin')) {
					console.log('Redirecting - doUserAuth 1');
					window.location.replace('/');
					return 'At signin, already authed';
				}
				if (window.authType === 'admin' || window.authType === 'nth admin') {
					// initApp()
					return { Authentication: 'Admin ' + window.authenticated };
				} else {
					if (!pn.includes('/admin')) {
						// initApp()
						return { Authentication: 'User ' + window.authenticated };
					} else {
						console.log('Not authorized as an admin.');
						//if (pn == '/' && !currentlyRaising) { window.location.replace(authRedirect) }
						//alert("Not authorized as an admin.");
						if (pn != authRedirect) window.location.replace(authRedirect);
					}
				}
			} else {
				console.log('Not authorized for this site. client=' + client);
				signOut('Not authorized for this site: client=' + client); // Draconian...  but may be necessary with stale cookies
				//if (pn == '/' && !currentlyRaising) { window.location.replace(authRedirect) };
				//alert("Not authorized for this site.");
				if (pn != authRedirect) window.location.replace(authRedirect);
			}
		}

		if (window.USE_AUTHENTICATOR || window.authenticatorValue == 'SignIn') authenticateIfNeeded();
		else carryOnLoading();
	}
}

// CapTableModule - Historic cap table rollup calculation
// Used by ledgers.js for record date allocations
const CapTableModule = {
	// Calculate historic cap table by rolling back transactions to a given date
	historicRollup: (inputCapTable, inputClientData, inputCapTableAsOfTimestamp, extTransactionData) => {
		const capTableAsOfTimestampInSeconds = Math.floor(inputCapTableAsOfTimestamp.getTime() / 1000);
		const shouldFilterNegatives = !isAlera && !isTCA && !isCER;

		let dataByShareholder = {};
		const shareClasses = Object.keys(inputClientData.equity);
		shareClasses.forEach((shareClass) => {
			let shareClassTransactions = [];

			if (extTransactionData) {
				console.log('Client is using external transaction data, will pre-process external data');
				shareClassTransactions = extTransactionData.filter((t) => t.shareClass === shareClass);
			} else {
				shareClassTransactions = inputClientData.equity[shareClass].transactions || [];
			}

			// Seed data structure for each shareholder
			inputCapTable.forEach((holder) => {
				let shareholderUserId = holder.userid.toLowerCase();
				let existingShareholderData = dataByShareholder[shareholderUserId];
				if (!existingShareholderData) {
					dataByShareholder[shareholderUserId] = {
						contributions: [],
						tags: holder.clients?.[client]?.tags || [],
					};
				}
			});

			// Track matching transactions as contributions
			inputCapTable.forEach((holder) => {
				let shareholderUserId = holder.userid.toLowerCase();

				const filterToDate = (t) => Number(t.date) <= capTableAsOfTimestampInSeconds;
				const filterToSender = (t) => {
					const { sender } = t;
					return sender && sender.toLowerCase() === shareholderUserId;
				};
				const filterToReceiver = (t) => {
					const { receiver } = t;
					return receiver && receiver.toLowerCase() === shareholderUserId;
				};

				let holderClassEvents = [];

				shareClassTransactions.forEach((t) => {
					if (filterToDate(t)) {
						const isSender = filterToSender(t);
						const isReceiver = filterToReceiver(t);

						if (isSender || isReceiver) {
							let eventNrid = isSender ? 'transactionSender' : 'transactionReceiver';
							holderClassEvents.push({
								date: t.date,
								grossDollars: Number(t.quantity.replace(/[^-.\d]/g, '')).toString(),
								nrid: eventNrid,
							});
						}
					}
				});

				const filteredShareClassTransactions = shareClassTransactions.filter(filterToDate);
				filteredShareClassTransactions.forEach((t) => {
					const { sender, receiver } = t;
					if (sender && sender.includes('@') && shareholderUserId === sender.toLowerCase()) {
						const capTableHolder = inputCapTable.find((h) => h.userid.toLowerCase() === sender.toLowerCase());
						if (capTableHolder) {
							const holderData = dataByShareholder[capTableHolder.userid.toLowerCase()];
							if (holderData) {
								holderData.contributions.push({
									amount: -t.quantity,
									shareClass: shareClass,
									name: capTableHolder.user_name,
								});
							}
						}
					}
					if (receiver && receiver.includes('@') && shareholderUserId === receiver.toLowerCase()) {
						const capTableHolder = inputCapTable.find((h) => h.userid.toLowerCase() === receiver.toLowerCase());
						if (capTableHolder) {
							const holderData = dataByShareholder[capTableHolder.userid.toLowerCase()];
							if (holderData) {
								holderData.contributions.push({
									amount: t.quantity,
									shareClass: shareClass,
									name: capTableHolder.user_name,
								});
							}
						}
					}
				});
			});
		});

		// Build return data structure
		const userIds = Object.keys(dataByShareholder);
		let capTableRowsBaseObject = {};
		userIds.forEach((userid) => {
			const shareholder = {
				...dataByShareholder[userid],
				userid: userid,
			};
			const { contributions } = shareholder;
			const lastContribution = contributions[contributions.length - 1];
			if (lastContribution) {
				const mostRecentName = lastContribution.name;
				capTableRowsBaseObject[mostRecentName] = shareholder;
			}
		});

		let capTableRows = [];
		const sortedShareholderNames = Object.keys(capTableRowsBaseObject).sort((a, b) => {
			return a.toLowerCase().localeCompare(b.toLowerCase());
		});
		sortedShareholderNames.forEach((userName) => {
			const shareholder = capTableRowsBaseObject[userName];
			const { contributions } = shareholder;

			let contributionsByClass = {};
			let totalShares = 0;

			contributions.forEach((c) => {
				const { amount, shareClass } = c;
				totalShares += Number(String(amount).replace(/[^-.\d]/g, ''));
				contributionsByClass[shareClass] = contributionsByClass[shareClass] || [];
				contributionsByClass[shareClass].push(c);
			});

			const sortedShareClasses = [...Object.keys(contributionsByClass)].sort();
			capTableRows.push({
				contributionsByClass: contributionsByClass,
				user_name: userName,
				userid: shareholder.userid,
				lastSeen: '???',
				classes: sortedShareClasses,
				shares: totalShares,
				tags: shareholder.tags || [],
			});
		});
		return capTableRows;
	},
};
window.CapTableModule = CapTableModule;

// Bridge all functions to window.* for page scripts that use bare names
window.getEnv = getEnv;
window.getClient = getClient;
window.getCookie = getCookie;
window.checkCookie = checkCookie;
window.checkCookieWithRetry = checkCookieWithRetry;
window.checkAuth = checkAuth;
window.getAuthType = getAuthType;
window.checkAdmin = checkAdmin;
window.signOut = signOut;
window.hideLoading = hideLoading;
window.showLoading = showLoading;
window.holderClickFeedback = holderClickFeedback;
window.showToast = showToast;

// ---- Cross-account write checkpoint ---------------------------------------------------------
// While someone else's account is on screen (admin/supervisor preview, or an observer viewing an
// alias account), a save aimed at the signed-in person's OWN record is how one account's data can
// land on another's. Such saves are blocked during a preview (alerted for observers) unless they
// only touch activity tracking. Applies to every axios call to update-user / update-user-client-data.
const SELF_WRITE_SAFE_FIELDS = new Set(['lastActive']);
const WRITE_META_FIELDS = new Set(['eventName', 'userid', 'client', 'cookie', 'investor', 'holder', 'io.nthround.env']);

function crossAccountWriteCheck(config) {
	try {
		const url = String(config?.url || '');
		if (!/\/portal\/user\/update-user(-client-data)?(\?|$)/.test(url)) return config;
		if (String(config.method || 'get').toLowerCase() !== 'post') return config;
		const viewed = window.userData?.userid;
		if (!viewed || !authedUser || viewed === authedUser) return config;

		let body = config.data;
		if (typeof body === 'string') body = JSON.parse(body);
		if (!body || typeof body !== 'object') return config;
		const target = body.investor || body.holder || body.userid || authedUser;
		if (target !== authedUser) return config;

		// Only activity tracking (lastActive) may be saved to the signed-in person while viewing another account
		const fields = Object.keys(body).filter((k) => !WRITE_META_FIELDS.has(k));
		const clientNode = body.clients?.[client];
		const onlySafe =
			fields.every((k) => k === 'clients') &&
			(!body.clients ||
				(Object.keys(body.clients).every((c) => c === client) && clientNode && Object.keys(clientNode).every((k) => SELF_WRITE_SAFE_FIELDS.has(k))));
		if (onlySafe) return config;

		const previewing = Boolean(sessionStorage.getItem('previewer')) || getAuthType().includes('admin') || window.isSupv || window.isExec;
		const detail =
			'signed in = ' +
			authedUser +
			'<br>viewing = ' +
			viewed +
			'<br>eventName = ' +
			(body.eventName || '') +
			'<br>fields = ' +
			[...fields, ...Object.keys(clientNode || {}).map((k) => 'clients.' + k)].join(', ') +
			'<br>page = ' +
			window.location.pathname +
			'<br>' +
			(previewing ? 'BLOCKED' : 'allowed (observer, report-only)');
		console.error('[cross-account write] ' + detail.replace(/<br>/g, ' | '));
		sendAlert('Cross-account write ' + (previewing ? 'BLOCKED' : 'flagged') + ' (' + client + ')', detail);
		if (!previewing) return config;
		window.showToast?.('error-toast', '⚠️ That change was not saved: you are viewing another account.');
		return Promise.reject(new Error('Blocked: save to your own record while viewing ' + viewed));
	} catch (e) {
		console.error('[cross-account write] check failed', e);
		return config;
	}
}
if (typeof axios !== 'undefined' && !window.__nthCrossAccountCheck) {
	window.__nthCrossAccountCheck = true;
	axios.interceptors.request.use(crossAccountWriteCheck);
}
window.removeNthAdmins = removeNthAdmins;
window.user_identity = user_identity;
window.getPayerEmail = getPayerEmail;
window.doBlur = doBlur;
window.sortByDate = sortByDate;
window.sortByFFM = sortByFFM;
window.formatImg = formatImg;
window.formatPreview = formatPreview;
window.capitalize = capitalize;
window.singular = singular;
window.firstName = firstName;
window.nameWithOverride = nameWithOverride;
window.ensureUserClientData = ensureUserClientData;
window.friendlyNameWithOverride = friendlyNameWithOverride;
window.getInitials = getInitials;
window.dateTimeUTC = dateTimeUTC;
window.timeStampUTC = timeStampUTC;
window.uuidv4 = uuidv4;
window.customFormat = customFormat;
window.roundToFour = roundToFour;
window.evaluateAsFloat = evaluateAsFloat;
window.getCAGR = getCAGR;
window.initializeTags = initializeTags;
window.geocodeAddress = geocodeAddress;
window.verifyAddressOverridable = verifyAddressOverridable;
window.splitAddressFields = splitAddressFields;
window.export_table_to_excel = export_table_to_excel;
window.download_csv = download_csv;
window.cleanCSV = cleanCSV;
window.stripSubAddress = stripSubAddress;
window.itsTempAddress = itsTempAddress;
window.itsTreasury = itsTreasury;
window.cleanStampedName = cleanStampedName;
window.sanitizeHeaderFilename = sanitizeHeaderFilename;
window.formatPhone = formatPhone;
window.formatSSN = formatSSN;
window.formatEIN = formatEIN;
window.maskTaxIdLast4 = maskTaxIdLast4;
window.normalizeDate = normalizeDate;
window.labelIdNumber = labelIdNumber;
window.getAllUrlParams = getAllUrlParams;
window.secureFormData = secureFormData;
window.sendAlert = sendAlert;
window.send_dashboard_request = send_dashboard_request;
window.async_lambda = async_lambda;
window.deleteCookie = deleteCookie;
window.getCertNumber = getCertNumber;
window.numToWords = numToWords;
window.decimalToWords = decimalToWords;
window.stringifyNumber = stringifyNumber;
window.arr = arr;
window.num = num;
window.str = str;
window.isEmpty = isEmpty;
window.take = take;
window.drop = drop;
window.reverse = reverse;
window.comp = comp;
window.not = not;
window.chunk = chunk;

// Exports for index.js
export { AppState } from './helpers/app-state.js';
export {
	checkAuth,
	getCookie,
	getAuthedUser,
	getClient,
	getEnv,
	getAuthType,
	checkAdmin,
	signOut,
	hideLoading,
	showLoading,
	showToast,
	LZString,
	NthUtil,
	CapTableModule,
	client,
	authedUser,
	nthAdmin,
	env,
	removeNthAdmins,
	deleteCookie,
};
